import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { map, pluck, take, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import { saveAs } from 'file-saver';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@angular/forms';
import { Validators, FormArray, ReactiveFormsModule } from '@angular/forms';
import { environment } from 'environment-configurations';
import * as i3 from 'bulk-upload-dashboard';
import * as i4 from 'primeng/api';
import * as i5 from 'custom-button-action';
import * as i6 from 'new-talent-upload';
import * as i7 from 'view-candidate-details';
import * as i8 from 'ngx-toastr';
import * as i9 from '@ngrx/store';
import * as i10 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i11 from 'primeng/dialog';
import * as i12 from 'primeng/dropdown';
import * as i13 from 'primeng/chips';
import * as i14 from 'primeng/tooltip';
import * as i15 from 'primeng/button';
import * as i16 from 'primeng/radiobutton';
import { PrimengLibraryModule } from 'primeng-library';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

class TalentEditDetailsService {
    constructor(http) {
        this.http = http;
        this.bulkuploadbackclickflag = '';
        // sendbulkuploadbackclickflag(value: string) {
        //   this.bulkuploadbackclickflag.next({ flag: value });
        // }
        // getbulkuploadbackclickflag(): Observable<any> {
        //   return this.bulkuploadbackclickflag.asObservable();
        // }
        this.onLoadResponseSubject = new BehaviorSubject(null);
    }
    getApplicantStatus() {
        return this.http.get(`/vd/dataSource/APPLICANTSTATUS/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getPageFormById(pageBuilderId) {
        return this.http.get(`/vd/formBuilder/${pageBuilderId}/createdPageForm`).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
    editErrorDocument(errorId) {
        return this.http.get('/vd/formBuilder/talentpool/bulkupload/applicant/' + errorId + '/details').pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    getQualification() {
        return this.http.get(`/careerportal/FB_CAREER_PORTAL_EMPLOYEE_QUALIFICATION/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getExperienceYear() {
        return this.http.get(`/vd/dataSource/FB_EXP_YEAR/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getExperienceMonth() {
        return this.http.get(`/vd/dataSource/FB_EXP_MONTH/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getJoiningMonth() {
        return this.http.get(`/vd/dataSource/FBMONTHNAME/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getCTC() {
        return this.http.get(`/vd/dataSource/FB_CAREER_PORTAL_EMPLOYEE_CTC/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getEmploymentType() {
        return this.http.get(`/vd/dataSource/FB_CAREER_PORTAL_EMPLOYMENT_TYPE/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getJobType() {
        return this.http.get(`/vd/dataSource/FB_CAREER_PORTAL_JOB_TYPE/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getJobCategory() {
        return this.http.get(`/vd/dataSource/FB_CAREER_PORTAL_JOB_CATEGORY/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getStartingYear() {
        return this.http.get(`/vd/dataSource/FB_CAL_YEAR/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getNoticePeriod() {
        return this.http.get(`/vd/dataSource/FB_ONB_NOTICE_PERIOD/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getSpecialization() {
        return this.http.get(`/vd/dataSource/FB_CAREER_PORTAL_EDUCATION_SPECIALIZATION/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getCourse() {
        return this.http.get(`/careerportal/FB_CAREER_PORTAL_EDUCATION_COURSE/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getCourseType() {
        return this.http.get(`/vd/dataSource/FB_CAREER_PORTAL_EDUCATION_COURSETYPE/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getCountries() {
        return this.http.get(`/careerportal/COUNTRY/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getStates(code) {
        return this.http.get(`/careerportal/STATEPROVINCE/elements?code=` + code).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    deleteResume(errorID) {
        return this.http.delete(`/vd/formBuilder/talentpool/bulkupload/${errorID}/delete`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    saveInfo(payload) {
        return this.http.post(`/vd/fb/save/talentAcq/saveApplicant`, payload).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getINRctc() {
        return this.http.get(`/careerportal/FB_CAREER_PORTAL_EMPLOYEE_CTC_INR/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    downloadDocuments(path, fileName) {
        this.http.get(path, { responseType: "arraybuffer" })
            .pipe(take(1))
            .subscribe(file => {
            const blob = new Blob([file], { type: 'text/csv' });
            saveAs(blob, fileName);
        });
    }
    delete(Id) {
        return this.http.delete(`/vd/fb/delete/talentAcq/applicant/docId/${Id}`).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
}
TalentEditDetailsService.ɵfac = function TalentEditDetailsService_Factory(t) { return new (t || TalentEditDetailsService)(i0.ɵɵinject(i1.HttpClient)); };
TalentEditDetailsService.ɵprov = i0.ɵɵdefineInjectable({ token: TalentEditDetailsService, factory: TalentEditDetailsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TalentEditDetailsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function TalentEditDetailsComponent_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function TalentEditDetailsComponent_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.backToParentPage(); });
    i0.ɵɵelement(1, "i", 9);
    i0.ɵɵtext(2, " Back ");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_13_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "First name is required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_13_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.f.firstName.errors.required);
} }
function TalentEditDetailsComponent_div_3_div_20_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Last name is required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_20_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.f.lastName.errors.required);
} }
function TalentEditDetailsComponent_div_3_div_31_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Email is required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_31_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.f.emailId.errors.required);
} }
function TalentEditDetailsComponent_div_3_div_39_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Contact Number is required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_39_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_39_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.f.contactNumber.errors.required);
} }
function TalentEditDetailsComponent_div_3_div_46_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Years of experience is required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_46_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_46_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.f.experience.errors.required);
} }
function TalentEditDetailsComponent_div_3_div_53_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Country is required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_53_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_53_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.f.country.errors.required);
} }
function TalentEditDetailsComponent_div_3_div_60_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "State is required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_60_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_60_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.f.state.errors.required);
} }
function TalentEditDetailsComponent_div_3_div_61_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "div", 37);
    i0.ɵɵelementStart(2, "p", 16);
    i0.ɵɵtext(3, "Skills Used");
    i0.ɵɵelementStart(4, "sup");
    i0.ɵɵtext(5, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "p-chips", 38);
    i0.ɵɵlistener("onAdd", function TalentEditDetailsComponent_div_3_div_61_Template_p_chips_onAdd_6_listener($event) { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(2); return ctx_r24.onSkillsAdd($event); })("onRemove", function TalentEditDetailsComponent_div_3_div_61_Template_p_chips_onRemove_6_listener($event) { i0.ɵɵrestoreView(_r25); const ctx_r26 = i0.ɵɵnextContext(2); return ctx_r26.skillRemove($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c0 = function () { return { "width": "100%" }; };
function TalentEditDetailsComponent_div_3_div_62_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵelementStart(2, "h5");
    i0.ɵɵtext(3, "Status update");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 15);
    i0.ɵɵelementStart(5, "p", 16);
    i0.ɵɵtext(6, "Status");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "p-dropdown", 39);
    i0.ɵɵlistener("onChange", function TalentEditDetailsComponent_div_3_div_62_Template_p_dropdown_onChange_7_listener($event) { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(2); return ctx_r27.onStatusChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(7);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(3, _c0));
    i0.ɵɵproperty("options", ctx_r12.getStatusDetails);
} }
function TalentEditDetailsComponent_div_3_div_67_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 50);
    i0.ɵɵlistener("click", function TalentEditDetailsComponent_div_3_div_67_button_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r41); const i_r30 = i0.ɵɵnextContext().index; const ctx_r39 = i0.ɵɵnextContext(2); return ctx_r39.removeEducation(i_r30); });
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_67_div_10_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Education is required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_67_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_67_div_10_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r30 = i0.ɵɵnextContext().index;
    const ctx_r32 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r32.fEducation[i_r30].controls.educationId.errors.required);
} }
function TalentEditDetailsComponent_div_3_div_67_div_17_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "University is required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_67_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_67_div_17_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r30 = i0.ɵɵnextContext().index;
    const ctx_r33 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r33.fEducation[i_r30].controls.universityName.errors.required);
} }
function TalentEditDetailsComponent_div_3_div_67_div_24_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Course is required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_67_div_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_67_div_24_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r30 = i0.ɵɵnextContext().index;
    const ctx_r34 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r34.fEducation[i_r30].controls.courseId.errors.required);
} }
function TalentEditDetailsComponent_div_3_div_67_div_32_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Specialization is required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_67_div_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_67_div_32_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r30 = i0.ɵɵnextContext().index;
    const ctx_r35 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r35.fEducation[i_r30].controls.specializationId.errors.required);
} }
function TalentEditDetailsComponent_div_3_div_67_div_39_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Course Type is required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_67_div_39_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_67_div_39_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r30 = i0.ɵɵnextContext().index;
    const ctx_r36 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r36.fEducation[i_r30].controls.courseTypeId.errors.required);
} }
function TalentEditDetailsComponent_div_3_div_67_div_46_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Course Starting Year is required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_67_div_46_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_67_div_46_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r30 = i0.ɵɵnextContext().index;
    const ctx_r37 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r37.fEducation[i_r30].controls.courseStartYear.errors.required);
} }
function TalentEditDetailsComponent_div_3_div_67_div_53_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Course Ending Year is required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_67_div_53_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_67_div_53_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r30 = i0.ɵɵnextContext().index;
    const ctx_r38 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r38.fEducation[i_r30].controls.courseEndYear.errors.required);
} }
const _c1 = function (a0) { return { "is-invalid": a0 }; };
function TalentEditDetailsComponent_div_3_div_67_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵelementStart(2, "h6", 41);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, TalentEditDetailsComponent_div_3_div_67_button_4_Template, 1, 0, "button", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 14);
    i0.ɵɵelementStart(6, "div", 15);
    i0.ɵɵelementStart(7, "p", 16);
    i0.ɵɵtext(8, "Education");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "p-dropdown", 43);
    i0.ɵɵtemplate(10, TalentEditDetailsComponent_div_3_div_67_div_10_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 37);
    i0.ɵɵelementStart(12, "p", 16);
    i0.ɵɵtext(13, "University/Institute");
    i0.ɵɵelementStart(14, "sup");
    i0.ɵɵtext(15, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(16, "input", 44);
    i0.ɵɵtemplate(17, TalentEditDetailsComponent_div_3_div_67_div_17_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 15);
    i0.ɵɵelementStart(19, "p", 16);
    i0.ɵɵtext(20, "Course");
    i0.ɵɵelementStart(21, "sup");
    i0.ɵɵtext(22, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(23, "p-dropdown", 45);
    i0.ɵɵtemplate(24, TalentEditDetailsComponent_div_3_div_67_div_24_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 14);
    i0.ɵɵelementStart(26, "div", 15);
    i0.ɵɵelementStart(27, "p", 16);
    i0.ɵɵtext(28, "Specialization");
    i0.ɵɵelementStart(29, "sup");
    i0.ɵɵtext(30, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(31, "p-dropdown", 46);
    i0.ɵɵtemplate(32, TalentEditDetailsComponent_div_3_div_67_div_32_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "div", 15);
    i0.ɵɵelementStart(34, "p", 16);
    i0.ɵɵtext(35, "Course Type");
    i0.ɵɵelementStart(36, "sup");
    i0.ɵɵtext(37, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(38, "p-dropdown", 47);
    i0.ɵɵtemplate(39, TalentEditDetailsComponent_div_3_div_67_div_39_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "div", 15);
    i0.ɵɵelementStart(41, "p", 16);
    i0.ɵɵtext(42, "Course Starting Year");
    i0.ɵɵelementStart(43, "sup");
    i0.ɵɵtext(44, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(45, "p-dropdown", 48);
    i0.ɵɵtemplate(46, TalentEditDetailsComponent_div_3_div_67_div_46_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(47, "div", 15);
    i0.ɵɵelementStart(48, "p", 16);
    i0.ɵɵtext(49, "Course Ending Year");
    i0.ɵɵelementStart(50, "sup");
    i0.ɵɵtext(51, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(52, "p-dropdown", 49);
    i0.ɵɵtemplate(53, TalentEditDetailsComponent_div_3_div_67_div_53_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r30 = ctx.index;
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroupName", i_r30);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" Education ", i_r30 + 1, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r30 != 0);
    i0.ɵɵadvance(5);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(36, _c0));
    i0.ɵɵproperty("options", ctx_r13.qualifications)("ngClass", i0.ɵɵpureFunction1(37, _c1, ctx_r13.submitted && ctx_r13.fEducation[i_r30]["controls"].educationId.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.submitted && ctx_r13.fEducation[i_r30].controls.educationId.errors);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(39, _c1, ctx_r13.submitted && ctx_r13.fEducation[i_r30]["controls"].universityName.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.submitted && ctx_r13.fEducation[i_r30].controls.universityName.errors);
    i0.ɵɵadvance(6);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(41, _c0));
    i0.ɵɵproperty("options", ctx_r13.courses)("ngClass", i0.ɵɵpureFunction1(42, _c1, ctx_r13.submitted && ctx_r13.fEducation[i_r30]["controls"].courseId.errors))("required", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.submitted && ctx_r13.fEducation[i_r30].controls.courseId.errors);
    i0.ɵɵadvance(7);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(44, _c0));
    i0.ɵɵproperty("options", ctx_r13.specializations)("ngClass", i0.ɵɵpureFunction1(45, _c1, ctx_r13.submitted && ctx_r13.fEducation[i_r30]["controls"].specializationId.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.submitted && ctx_r13.fEducation[i_r30].controls.specializationId.errors);
    i0.ɵɵadvance(6);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(47, _c0));
    i0.ɵɵproperty("options", ctx_r13.courseType)("ngClass", i0.ɵɵpureFunction1(48, _c1, ctx_r13.submitted && ctx_r13.fEducation[i_r30]["controls"].courseTypeId.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.submitted && ctx_r13.fEducation[i_r30].controls.courseTypeId.errors);
    i0.ɵɵadvance(6);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(50, _c0));
    i0.ɵɵproperty("options", ctx_r13.courseStartingYears)("ngClass", i0.ɵɵpureFunction1(51, _c1, ctx_r13.submitted && ctx_r13.fEducation[i_r30]["controls"].courseStartYear.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.submitted && ctx_r13.fEducation[i_r30].controls.courseStartYear.errors);
    i0.ɵɵadvance(6);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(53, _c0));
    i0.ɵɵproperty("options", ctx_r13.courseStartingYears)("ngClass", i0.ɵɵpureFunction1(54, _c1, ctx_r13.submitted && ctx_r13.fEducation[i_r30]["controls"].courseEndYear.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.submitted && ctx_r13.fEducation[i_r30].controls.courseEndYear.errors);
} }
function TalentEditDetailsComponent_div_3_div_74_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r79 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 50);
    i0.ɵɵlistener("click", function TalentEditDetailsComponent_div_3_div_74_button_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r79); const i_r57 = i0.ɵɵnextContext().index; const ctx_r77 = i0.ɵɵnextContext(2); return ctx_r77.removeEmployment(i_r57); });
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_74_div_15_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Employment Type is required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_74_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_74_div_15_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r57 = i0.ɵɵnextContext().index;
    const ctx_r59 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r59.fEmployment[i_r57].controls.employmentTypeId.errors.required);
} }
function TalentEditDetailsComponent_div_3_div_74_div_20_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Years of experience is required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_74_div_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_74_div_20_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r57 = i0.ɵɵnextContext().index;
    const ctx_r60 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r60.fEmployment[i_r57].controls.totalExperienceInYears.errors.required);
} }
function TalentEditDetailsComponent_div_3_div_74_div_25_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Experience is required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_74_div_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_74_div_25_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r57 = i0.ɵɵnextContext().index;
    const ctx_r61 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r61.fEmployment[i_r57].controls.totalExperienceInMonths.errors.required);
} }
function TalentEditDetailsComponent_div_3_div_74_div_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementStart(1, "p", 16);
    i0.ɵɵtext(2, "Ending Year");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p-dropdown", 65);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r62 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(3, _c0));
    i0.ɵɵproperty("options", ctx_r62.courseStartingYears);
} }
function TalentEditDetailsComponent_div_3_div_74_div_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementStart(1, "p", 16);
    i0.ɵɵtext(2, "Ending Month");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p-dropdown", 66);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r63 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(3, _c0));
    i0.ɵɵproperty("options", ctx_r63.getJoiningMonths);
} }
function TalentEditDetailsComponent_div_3_div_74_div_33_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Company name is required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_74_div_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_74_div_33_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r57 = i0.ɵɵnextContext().index;
    const ctx_r64 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r64.fEmployment[i_r57].controls.companyName.errors.required);
} }
function TalentEditDetailsComponent_div_3_div_74_div_38_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Designation is required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_74_div_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_74_div_38_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r57 = i0.ɵɵnextContext().index;
    const ctx_r65 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r65.fEmployment[i_r57].controls.designation.errors.required);
} }
function TalentEditDetailsComponent_div_3_div_74_div_43_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Joining Year is required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_74_div_43_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_74_div_43_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r57 = i0.ɵɵnextContext().index;
    const ctx_r66 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r66.fEmployment[i_r57].controls.joiningDateInYear.errors.required);
} }
function TalentEditDetailsComponent_div_3_div_74_div_48_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Joining Month is required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_74_div_48_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_74_div_48_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r57 = i0.ɵɵnextContext().index;
    const ctx_r67 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r67.fEmployment[i_r57].controls.joiningDateInMonth.errors.required);
} }
function TalentEditDetailsComponent_div_3_div_74_div_54_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Current CTC is required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_74_div_54_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_74_div_54_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r57 = i0.ɵɵnextContext().index;
    const ctx_r68 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r68.fEmployment[i_r57].controls.ctcId.errors.required);
} }
function TalentEditDetailsComponent_div_3_div_74_p_dropdown_58_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-dropdown", 67);
} if (rf & 2) {
    const i_r57 = i0.ɵɵnextContext().index;
    const ctx_r69 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(4, _c0));
    i0.ɵɵproperty("options", ctx_r69.getNPValues)("ngClass", i0.ɵɵpureFunction1(5, _c1, ctx_r69.submitted && ctx_r69.fEmployment[i_r57]["controls"].noticePeriod.errors));
} }
function TalentEditDetailsComponent_div_3_div_74_ng_template_59_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 68);
} if (rf & 2) {
    const i_r57 = i0.ɵɵnextContext().index;
    const ctx_r71 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c1, ctx_r71.submitted && ctx_r71.fEmployment[i_r57]["controls"].noticePeriod.errors));
} }
function TalentEditDetailsComponent_div_3_div_74_div_61_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Notice Period is required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_74_div_61_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_74_div_61_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r57 = i0.ɵɵnextContext().index;
    const ctx_r72 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r72.fEmployment[i_r57].controls.noticePeriod.errors.required);
} }
function TalentEditDetailsComponent_div_3_div_74_div_62_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Ending Year is required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_74_div_62_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_74_div_62_div_4_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r57 = i0.ɵɵnextContext(2).index;
    const ctx_r100 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r100.fEmployment[i_r57].controls.endDateInYear.errors.required);
} }
function TalentEditDetailsComponent_div_3_div_74_div_62_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementStart(1, "p", 16);
    i0.ɵɵtext(2, "Ending Year");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p-dropdown", 69);
    i0.ɵɵtemplate(4, TalentEditDetailsComponent_div_3_div_74_div_62_div_4_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r57 = i0.ɵɵnextContext().index;
    const ctx_r73 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(5, _c0));
    i0.ɵɵproperty("options", ctx_r73.courseStartingYears)("ngClass", i0.ɵɵpureFunction1(6, _c1, ctx_r73.submitted && ctx_r73.fEmployment[i_r57]["controls"].endDateInYear.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r73.submitted && ctx_r73.fEmployment[i_r57].controls.endDateInYear.errors);
} }
function TalentEditDetailsComponent_div_3_div_74_div_63_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Ending Month is required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_74_div_63_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_74_div_63_div_4_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r57 = i0.ɵɵnextContext(2).index;
    const ctx_r104 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r104.fEmployment[i_r57].controls.endDateInMonth.errors.required);
} }
function TalentEditDetailsComponent_div_3_div_74_div_63_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementStart(1, "p", 16);
    i0.ɵɵtext(2, "Ending Month");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p-dropdown", 70);
    i0.ɵɵtemplate(4, TalentEditDetailsComponent_div_3_div_74_div_63_div_4_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r57 = i0.ɵɵnextContext().index;
    const ctx_r74 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(5, _c0));
    i0.ɵɵproperty("options", ctx_r74.getJoiningMonths)("ngClass", i0.ɵɵpureFunction1(6, _c1, ctx_r74.submitted && ctx_r74.fEmployment[i_r57]["controls"].endDateInMonth.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r74.submitted && ctx_r74.fEmployment[i_r57].controls.endDateInMonth.errors);
} }
function TalentEditDetailsComponent_div_3_div_74_div_64_Template(rf, ctx) { if (rf & 1) {
    const _r109 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "div", 37);
    i0.ɵɵelementStart(2, "p", 16);
    i0.ɵɵtext(3, "Skills Used");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p-chips", 71);
    i0.ɵɵlistener("onAdd", function TalentEditDetailsComponent_div_3_div_74_div_64_Template_p_chips_onAdd_4_listener($event) { i0.ɵɵrestoreView(_r109); const ctx_r108 = i0.ɵɵnextContext(3); return ctx_r108.onSkillsAdd($event); })("onRemove", function TalentEditDetailsComponent_div_3_div_74_div_64_Template_p_chips_onRemove_4_listener($event) { i0.ɵɵrestoreView(_r109); const ctx_r110 = i0.ɵɵnextContext(3); return ctx_r110.skillRemove($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r75 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("max", ctx_r75.max);
} }
function TalentEditDetailsComponent_div_3_div_74_div_70_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Job Roles and Responsibilities are required");
    i0.ɵɵelementEnd();
} }
function TalentEditDetailsComponent_div_3_div_74_div_70_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_74_div_70_div_1_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r57 = i0.ɵɵnextContext().index;
    const ctx_r76 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r76.fEmployment[i_r57].controls.jobRolesAndRespon.errors.required);
} }
function TalentEditDetailsComponent_div_3_div_74_Template(rf, ctx) { if (rf & 1) {
    const _r114 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵelementStart(2, "h6", 41);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, TalentEditDetailsComponent_div_3_div_74_button_4_Template, 1, 0, "button", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 14);
    i0.ɵɵelementStart(6, "div", 15);
    i0.ɵɵelementStart(7, "p", 16);
    i0.ɵɵtext(8, "Is this your current employment?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p-radioButton", 51);
    i0.ɵɵlistener("onClick", function TalentEditDetailsComponent_div_3_div_74_Template_p_radioButton_onClick_9_listener() { i0.ɵɵrestoreView(_r114); const i_r57 = ctx.index; const ctx_r113 = i0.ɵɵnextContext(2); return ctx_r113.handleIsCurrentEmployement("Yes", i_r57); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "p-radioButton", 52);
    i0.ɵɵlistener("onClick", function TalentEditDetailsComponent_div_3_div_74_Template_p_radioButton_onClick_10_listener() { i0.ɵɵrestoreView(_r114); const i_r57 = ctx.index; const ctx_r115 = i0.ɵɵnextContext(2); return ctx_r115.handleIsCurrentEmployement("No", i_r57); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 15);
    i0.ɵɵelementStart(12, "p", 16);
    i0.ɵɵtext(13, "Employment Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "p-dropdown", 53);
    i0.ɵɵtemplate(15, TalentEditDetailsComponent_div_3_div_74_div_15_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 15);
    i0.ɵɵelementStart(17, "p", 16);
    i0.ɵɵtext(18, "Total Experience(Years)");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(19, "p-dropdown", 54);
    i0.ɵɵtemplate(20, TalentEditDetailsComponent_div_3_div_74_div_20_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 15);
    i0.ɵɵelementStart(22, "p", 16);
    i0.ɵɵtext(23, "Total Experience(Month)");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(24, "p-dropdown", 55);
    i0.ɵɵtemplate(25, TalentEditDetailsComponent_div_3_div_74_div_25_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(26, TalentEditDetailsComponent_div_3_div_74_div_26_Template, 4, 4, "div", 56);
    i0.ɵɵtemplate(27, TalentEditDetailsComponent_div_3_div_74_div_27_Template, 4, 4, "div", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div", 14);
    i0.ɵɵelementStart(29, "div", 15);
    i0.ɵɵelementStart(30, "p", 16);
    i0.ɵɵtext(31, "Company Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(32, "input", 57);
    i0.ɵɵtemplate(33, TalentEditDetailsComponent_div_3_div_74_div_33_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "div", 15);
    i0.ɵɵelementStart(35, "p", 16);
    i0.ɵɵtext(36, "Designation");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(37, "input", 58);
    i0.ɵɵtemplate(38, TalentEditDetailsComponent_div_3_div_74_div_38_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(39, "div", 15);
    i0.ɵɵelementStart(40, "p", 16);
    i0.ɵɵtext(41, "Joining Year");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(42, "p-dropdown", 59);
    i0.ɵɵtemplate(43, TalentEditDetailsComponent_div_3_div_74_div_43_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(44, "div", 15);
    i0.ɵɵelementStart(45, "p", 16);
    i0.ɵɵtext(46, "Joining Month");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(47, "p-dropdown", 60);
    i0.ɵɵtemplate(48, TalentEditDetailsComponent_div_3_div_74_div_48_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(49, "div", 14);
    i0.ɵɵelementStart(50, "div", 15);
    i0.ɵɵelementStart(51, "p", 16);
    i0.ɵɵtext(52, "CTC");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(53, "p-dropdown", 61);
    i0.ɵɵtemplate(54, TalentEditDetailsComponent_div_3_div_74_div_54_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(55, "div", 15);
    i0.ɵɵelementStart(56, "p", 16);
    i0.ɵɵtext(57, "Notice Period");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(58, TalentEditDetailsComponent_div_3_div_74_p_dropdown_58_Template, 1, 7, "p-dropdown", 62);
    i0.ɵɵtemplate(59, TalentEditDetailsComponent_div_3_div_74_ng_template_59_Template, 1, 3, "ng-template", null, 63, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(61, TalentEditDetailsComponent_div_3_div_74_div_61_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(62, TalentEditDetailsComponent_div_3_div_74_div_62_Template, 5, 8, "div", 56);
    i0.ɵɵtemplate(63, TalentEditDetailsComponent_div_3_div_74_div_63_Template, 5, 8, "div", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(64, TalentEditDetailsComponent_div_3_div_74_div_64_Template, 5, 1, "div", 26);
    i0.ɵɵelementStart(65, "div", 14);
    i0.ɵɵelementStart(66, "div", 37);
    i0.ɵɵelementStart(67, "p", 16);
    i0.ɵɵtext(68, "Job Roles and Responsibilities");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(69, "textarea", 64);
    i0.ɵɵtemplate(70, TalentEditDetailsComponent_div_3_div_74_div_70_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r57 = ctx.index;
    const _r70 = i0.ɵɵreference(60);
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroupName", i_r57);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" Employment ", i_r57 + 1, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r57 != 0);
    i0.ɵɵadvance(10);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(47, _c0));
    i0.ɵɵproperty("options", ctx_r14.employmentTypes)("ngClass", i0.ɵɵpureFunction1(48, _c1, ctx_r14.submitted && ctx_r14.fEmployment[i_r57]["controls"].employmentTypeId.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.submitted && ctx_r14.fEmployment[i_r57].controls.employmentTypeId.errors);
    i0.ɵɵadvance(4);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(50, _c0));
    i0.ɵɵproperty("options", ctx_r14.experienceYear)("ngClass", i0.ɵɵpureFunction1(51, _c1, ctx_r14.submitted && ctx_r14.fEmployment[i_r57]["controls"].totalExperienceInYears.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.submitted && ctx_r14.fEmployment[i_r57].controls.totalExperienceInYears.errors);
    i0.ɵɵadvance(4);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(53, _c0));
    i0.ɵɵproperty("options", ctx_r14.experienceMonth)("ngClass", i0.ɵɵpureFunction1(54, _c1, ctx_r14.submitted && ctx_r14.fEmployment[i_r57]["controls"].totalExperienceInMonths.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.submitted && ctx_r14.fEmployment[i_r57].controls.totalExperienceInMonths.errors);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.endDateFlag);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.endDateFlag);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(56, _c1, ctx_r14.submitted && ctx_r14.fEmployment[i_r57]["controls"].companyName.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.submitted && ctx_r14.fEmployment[i_r57].controls.companyName.errors);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(58, _c1, ctx_r14.submitted && ctx_r14.fEmployment[i_r57]["controls"].designation.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.submitted && ctx_r14.fEmployment[i_r57].controls.designation.errors);
    i0.ɵɵadvance(4);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(60, _c0));
    i0.ɵɵproperty("options", ctx_r14.courseStartingYears)("ngClass", i0.ɵɵpureFunction1(61, _c1, ctx_r14.submitted && ctx_r14.fEmployment[i_r57]["controls"].joiningDateInYear.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.submitted && ctx_r14.fEmployment[i_r57].controls.joiningDateInYear.errors);
    i0.ɵɵadvance(4);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(63, _c0));
    i0.ɵɵproperty("options", ctx_r14.getJoiningMonths)("ngClass", i0.ɵɵpureFunction1(64, _c1, ctx_r14.submitted && ctx_r14.fEmployment[i_r57]["controls"].joiningDateInMonth.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.submitted && ctx_r14.fEmployment[i_r57].controls.joiningDateInMonth.errors);
    i0.ɵɵadvance(5);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(66, _c0));
    i0.ɵɵproperty("options", ctx_r14.ctcValues)("ngClass", i0.ɵɵpureFunction1(67, _c1, ctx_r14.submitted && ctx_r14.fEmployment[i_r57]["controls"].ctcId.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.submitted && ctx_r14.fEmployment[i_r57].controls.ctcId.errors);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r14.candidateId == null)("ngIfElse", _r70);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r14.submitted && ctx_r14.fEmployment[i_r57].controls.noticePeriod.errors);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.fEmployment[i_r57].controls.isCurrentEmployment.value == 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.fEmployment[i_r57].controls.isCurrentEmployment.value == 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.editFlowName == "view_candidate" || ctx_r14.editFlowName == "bulk" || ctx_r14.candidateId != null);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(69, _c1, ctx_r14.submitted && ctx_r14.fEmployment[i_r57]["controls"].jobRolesAndRespon.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.submitted && ctx_r14.fEmployment[i_r57].controls.jobRolesAndRespon.errors);
} }
function TalentEditDetailsComponent_div_3_div_77_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r120 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 74);
    i0.ɵɵelementStart(1, "p", 75);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 76);
    i0.ɵɵelementStart(4, "div", 77);
    i0.ɵɵelementStart(5, "button", 78);
    i0.ɵɵlistener("click", function TalentEditDetailsComponent_div_3_div_77_div_1_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r120); const data_r117 = ctx.$implicit; const ctx_r119 = i0.ɵɵnextContext(3); return ctx_r119.viewResume(data_r117); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 77);
    i0.ɵɵelementStart(7, "button", 79);
    i0.ɵɵlistener("click", function TalentEditDetailsComponent_div_3_div_77_div_1_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r120); const data_r117 = ctx.$implicit; const ctx_r121 = i0.ɵɵnextContext(3); return ctx_r121.DownloadResume(data_r117); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 77);
    i0.ɵɵelementStart(9, "button", 80);
    i0.ɵɵlistener("click", function TalentEditDetailsComponent_div_3_div_77_div_1_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r120); const data_r117 = ctx.$implicit; const i_r118 = ctx.index; const ctx_r122 = i0.ɵɵnextContext(3); return ctx_r122.deleteConfirm(data_r117, i_r118); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const data_r117 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(data_r117.fileName);
} }
function TalentEditDetailsComponent_div_3_div_77_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 72);
    i0.ɵɵtemplate(1, TalentEditDetailsComponent_div_3_div_77_div_1_Template, 10, 1, "div", 73);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r15.getCandidateDetails.applicantInfo.file);
} }
function TalentEditDetailsComponent_div_3_div_78_Template(rf, ctx) { if (rf & 1) {
    const _r124 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 72);
    i0.ɵɵelementStart(1, "h5", 81);
    i0.ɵɵtext(2, "Resume");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 82);
    i0.ɵɵelementStart(4, "p", 75);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 76);
    i0.ɵɵelementStart(7, "div", 77);
    i0.ɵɵelementStart(8, "button", 78);
    i0.ɵɵlistener("click", function TalentEditDetailsComponent_div_3_div_78_Template_button_click_8_listener() { i0.ɵɵrestoreView(_r124); const ctx_r123 = i0.ɵɵnextContext(2); return ctx_r123.viewBulkResume(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 77);
    i0.ɵɵelementStart(10, "button", 79);
    i0.ɵɵlistener("click", function TalentEditDetailsComponent_div_3_div_78_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r124); const ctx_r125 = i0.ɵɵnextContext(2); return ctx_r125.DownloadBulkResume(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 77);
    i0.ɵɵelementStart(12, "button", 80);
    i0.ɵɵlistener("click", function TalentEditDetailsComponent_div_3_div_78_Template_button_click_12_listener() { i0.ɵɵrestoreView(_r124); const ctx_r126 = i0.ɵɵnextContext(2); return ctx_r126.deleteBulkFileConfirm(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r16.getCandidateDetails == null ? null : ctx_r16.getCandidateDetails.resumeName) ? ctx_r16.getCandidateDetails == null ? null : ctx_r16.getCandidateDetails.resumeName : ctx_r16.getCandidateDetails == null ? null : ctx_r16.getCandidateDetails.fbUploadApplicantDocs == null ? null : ctx_r16.getCandidateDetails.fbUploadApplicantDocs.fileName);
} }
function TalentEditDetailsComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r128 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "form", 11);
    i0.ɵɵlistener("ngSubmit", function TalentEditDetailsComponent_div_3_Template_form_ngSubmit_1_listener() { i0.ɵɵrestoreView(_r128); const ctx_r127 = i0.ɵɵnextContext(); return ctx_r127.saveTalentData(); });
    i0.ɵɵelementStart(2, "div", 12);
    i0.ɵɵelementStart(3, "div", 13);
    i0.ɵɵelementStart(4, "h5");
    i0.ɵɵtext(5, "Basic Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 14);
    i0.ɵɵelementStart(7, "div", 15);
    i0.ɵɵelementStart(8, "p", 16);
    i0.ɵɵtext(9, "First Name");
    i0.ɵɵelementStart(10, "sup");
    i0.ɵɵtext(11, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "input", 17);
    i0.ɵɵtemplate(13, TalentEditDetailsComponent_div_3_div_13_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 15);
    i0.ɵɵelementStart(15, "p", 16);
    i0.ɵɵtext(16, "Last Name");
    i0.ɵɵelementStart(17, "sup");
    i0.ɵɵtext(18, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(19, "input", 19);
    i0.ɵɵtemplate(20, TalentEditDetailsComponent_div_3_div_20_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 15);
    i0.ɵɵelementStart(22, "p", 16);
    i0.ɵɵtext(23, "Middle Name(Optional)");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(24, "input", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 15);
    i0.ɵɵelementStart(26, "p", 16);
    i0.ɵɵtext(27, "Email Id");
    i0.ɵɵelementStart(28, "sup");
    i0.ɵɵtext(29, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(30, "input", 21);
    i0.ɵɵtemplate(31, TalentEditDetailsComponent_div_3_div_31_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "div", 14);
    i0.ɵɵelementStart(33, "div", 15);
    i0.ɵɵelementStart(34, "p", 16);
    i0.ɵɵtext(35, "Contact Number");
    i0.ɵɵelementStart(36, "sup");
    i0.ɵɵtext(37, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(38, "input", 22);
    i0.ɵɵtemplate(39, TalentEditDetailsComponent_div_3_div_39_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "div", 15);
    i0.ɵɵelementStart(41, "p", 16);
    i0.ɵɵtext(42, "Total Experience(Years)");
    i0.ɵɵelementStart(43, "sup");
    i0.ɵɵtext(44, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(45, "p-dropdown", 23);
    i0.ɵɵtemplate(46, TalentEditDetailsComponent_div_3_div_46_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(47, "div", 15);
    i0.ɵɵelementStart(48, "p", 16);
    i0.ɵɵtext(49, "Country");
    i0.ɵɵelementStart(50, "sup");
    i0.ɵɵtext(51, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(52, "p-dropdown", 24);
    i0.ɵɵlistener("onChange", function TalentEditDetailsComponent_div_3_Template_p_dropdown_onChange_52_listener($event) { i0.ɵɵrestoreView(_r128); const ctx_r129 = i0.ɵɵnextContext(); return ctx_r129.onCountryChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(53, TalentEditDetailsComponent_div_3_div_53_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(54, "div", 15);
    i0.ɵɵelementStart(55, "p", 16);
    i0.ɵɵtext(56, "State");
    i0.ɵɵelementStart(57, "sup");
    i0.ɵɵtext(58, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(59, "p-dropdown", 25);
    i0.ɵɵlistener("onChange", function TalentEditDetailsComponent_div_3_Template_p_dropdown_onChange_59_listener($event) { i0.ɵɵrestoreView(_r128); const ctx_r130 = i0.ɵɵnextContext(); return ctx_r130.onStateChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(60, TalentEditDetailsComponent_div_3_div_60_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(61, TalentEditDetailsComponent_div_3_div_61_Template, 7, 0, "div", 26);
    i0.ɵɵtemplate(62, TalentEditDetailsComponent_div_3_div_62_Template, 8, 4, "div", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(63, "div", 27);
    i0.ɵɵelementStart(64, "div", 13);
    i0.ɵɵelementStart(65, "h5");
    i0.ɵɵtext(66, "Education Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(67, TalentEditDetailsComponent_div_3_div_67_Template, 54, 56, "div", 28);
    i0.ɵɵelementStart(68, "button", 29);
    i0.ɵɵlistener("click", function TalentEditDetailsComponent_div_3_Template_button_click_68_listener() { i0.ɵɵrestoreView(_r128); const ctx_r131 = i0.ɵɵnextContext(); return ctx_r131.addEducation(); });
    i0.ɵɵtext(69, "+ Add Education");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(70, "div", 30);
    i0.ɵɵelementStart(71, "div", 13);
    i0.ɵɵelementStart(72, "h5");
    i0.ɵɵtext(73, "Employment Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(74, TalentEditDetailsComponent_div_3_div_74_Template, 71, 71, "div", 28);
    i0.ɵɵelementStart(75, "button", 29);
    i0.ɵɵlistener("click", function TalentEditDetailsComponent_div_3_Template_button_click_75_listener() { i0.ɵɵrestoreView(_r128); const ctx_r132 = i0.ɵɵnextContext(); return ctx_r132.addEmployement(); });
    i0.ɵɵtext(76, "+ Add Employment");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(77, TalentEditDetailsComponent_div_3_div_77_Template, 2, 1, "div", 31);
    i0.ɵɵtemplate(78, TalentEditDetailsComponent_div_3_div_78_Template, 13, 1, "div", 31);
    i0.ɵɵelementStart(79, "div", 5);
    i0.ɵɵelementStart(80, "div", 32);
    i0.ɵɵelementStart(81, "button", 33);
    i0.ɵɵtext(82, " Save ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(83, "div", 1);
    i0.ɵɵelementStart(84, "button", 34);
    i0.ɵɵlistener("click", function TalentEditDetailsComponent_div_3_Template_button_click_84_listener() { i0.ɵɵrestoreView(_r128); const ctx_r133 = i0.ɵɵnextContext(); return ctx_r133.cancel(); });
    i0.ɵɵtext(85, " Cancel ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroup", ctx_r1.talentDetailsForm);
    i0.ɵɵadvance(11);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(31, _c1, ctx_r1.submitted && ctx_r1.f.firstName.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.submitted && ctx_r1.f.firstName.errors);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(33, _c1, ctx_r1.submitted && ctx_r1.f.lastName.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.submitted && ctx_r1.f.lastName.errors);
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(35, _c1, ctx_r1.submitted && ctx_r1.f.emailId.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.submitted && ctx_r1.f.emailId.errors);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(37, _c1, ctx_r1.submitted && ctx_r1.f.contactNumber.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.submitted && ctx_r1.f.contactNumber.errors);
    i0.ɵɵadvance(6);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(39, _c0));
    i0.ɵɵproperty("options", ctx_r1.experienceYear)("ngClass", i0.ɵɵpureFunction1(40, _c1, ctx_r1.submitted && ctx_r1.f.experience.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.submitted && ctx_r1.f.experience.errors);
    i0.ɵɵadvance(6);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(42, _c0));
    i0.ɵɵproperty("options", ctx_r1.countries)("ngClass", i0.ɵɵpureFunction1(43, _c1, ctx_r1.submitted && ctx_r1.f.country.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.submitted && ctx_r1.f.country.errors);
    i0.ɵɵadvance(6);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(45, _c0));
    i0.ɵɵproperty("options", ctx_r1.states)("ngClass", i0.ɵɵpureFunction1(46, _c1, ctx_r1.submitted && ctx_r1.f.state.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.submitted && ctx_r1.f.state.errors);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.editFlowName == "parsing_details");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.editFlowName == "view_acquisition_candidate");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r1.educations.controls);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngForOf", ctx_r1.employmentDetails.controls);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", (ctx_r1.editFlowName == "view_candidate" || ctx_r1.candidateId != null) && ctx_r1.resumeflag);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.editFlowName == "bulk" && ctx_r1.resumeflag);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", !ctx_r1.talentDetailsForm.valid);
} }
const _c2 = function () { return { width: "50vw" }; };
class TalentEditDetailsComponent {
    constructor(fb, talentEditDetailsService, bulkUploadDashboardService, primengConfig, customButtonActionService, newTalentUploadService, viewCandidateDetailsService, toastr, store) {
        this.fb = fb;
        this.talentEditDetailsService = talentEditDetailsService;
        this.bulkUploadDashboardService = bulkUploadDashboardService;
        this.primengConfig = primengConfig;
        this.customButtonActionService = customButtonActionService;
        this.newTalentUploadService = newTalentUploadService;
        this.viewCandidateDetailsService = viewCandidateDetailsService;
        this.toastr = toastr;
        this.store = store;
        this.subscription = [];
        this.observableSubscription$ = new Subject();
        this.getCandidateDetails = {};
        this.submitted = false;
        this.endDateFlag = false;
        this.noticePeriodDuration = [];
        this.editDetailsFlag = false;
        this.employementTypes = ['full', 'part'];
        this.max = 50;
        this.skillArray = [];
        this.ctcValues = [];
        this.getStatusDetails = [];
        this.qualifications = [];
        this.employmentTypes = [];
        this.countries = [];
        this.states = [];
        this.courseStartingYears = [];
        this.getJoiningMonths = [];
        this.getNPValues = [];
        this.isValidFormSubmitted = null;
        this.experienceYear = [];
        this.experienceMonth = [];
        this.specializationList = [];
        this.jobTypes = [];
        this.jobCategory = [];
        this.specializations = [];
        this.courseType = [];
        this.courses = [];
        this.educationDefaultvalue = { applicantInfoId: 0, courseEndYear: "", courseId: "", courseStartYear: "", createdDate: '', educationId: "", id: 0, courseTypeId: "", universityName: '', specializationId: "" };
        this.employmentDefaultvalue = {
            applicantInfoId: 0,
            companyName: '',
            createdDate: new Date(),
            ctcId: '',
            designation: '',
            employmentTypeId: "",
            id: 0,
            isCurrentEmployment: 1,
            jobRolesAndRespon: '',
            joiningDateInMonth: '',
            joiningDateInYear: '',
            endDateInMonth: '',
            endDateInYear: '',
            noticePeriod: '', totalExperienceInMonths: '', totalExperienceInYears: ''
        };
        this.disabledFlag = false;
        this.resumeflag = true;
        this.saveData = new EventEmitter();
    }
    ngOnInit() {
        this.subscription[this.subscription.length] = this.newTalentUploadService.getRadioChange().subscribe(data => {
            if (data.radio == "Manual") {
                this.editDetailsFlag = true;
            }
            else {
                this.editDetailsFlag = false;
            }
        });
        this.talentDetailsForm = this.fb.group({
            basicDetails: this.fb.group({
                firstName: ['', Validators.required],
                lastName: ['', Validators.required],
                middleName: [''],
                emailId: ['', Validators.required],
                contactNumber: ['', Validators.required],
                experience: ['', Validators.required],
                country: ['', Validators.required],
                state: ['', Validators.required],
                skillsUsed: [""],
                status: [""],
            }),
            educations: new FormArray([], [Validators.required]),
            employmentDetails: new FormArray([])
        });
        this.getNP();
        this.getEmploymentType();
        this.getExperienceYear();
        this.getExperienceMonth();
        this.getJobCategory();
        this.getJobType();
        this.getQualification();
        this.getCourseStartingYear();
        this.getJoiningMonth();
        this.getCourseType();
        this.getCourse();
        this.getStatus();
        this.getCountry();
        this.getSpecialization();
        this.getErrorID = this.bulkUploadDashboardService.getErrorId;
        this.editFlowName = this.bulkUploadDashboardService.editFlowflag;
        this.candidateId = 'applicantId' in sessionStorage ? parseInt(sessionStorage.getItem('applicantId')) : 'idToGetDetails' in sessionStorage ? parseInt(sessionStorage.getItem('idToGetDetails')) : null;
        if (this.editFlowName == 'bulk') {
            this.subscription[this.subscription.length] = this.talentEditDetailsService.editErrorDocument(this.getErrorID).subscribe((response) => {
                var _a, _b;
                if (response.data) {
                    this.getCandidateDetails = response.data;
                    if (this.getCandidateDetails) {
                        if (((_b = (_a = this.getCandidateDetails) === null || _a === void 0 ? void 0 : _a.applicantInfo) === null || _b === void 0 ? void 0 : _b.country) == 'USA') {
                            this.getState("USA");
                            this.getCTC();
                        }
                        else {
                            this.getState("IND");
                            this.getINRctc();
                        }
                        this.generateCandidate();
                        this.resumeflag = true;
                    }
                }
            });
        }
        else if (this.editFlowName == 'view_candidate' || this.candidateId != null || this.editFlowName == 'view_acquisition_candidate') {
            if (this.candidateId) {
                let applicantInfoId = 'applicantInfoId' in sessionStorage ? parseInt(sessionStorage.getItem('applicantInfoId')) : null;
                this.viewCandidateDetailsService.getCandidateDetails(this.candidateId, applicantInfoId).pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    if (response.data) {
                        this.getCandidateDetails = response.data || null;
                        if (this.getCandidateDetails) {
                            if (((_b = (_a = this.getCandidateDetails) === null || _a === void 0 ? void 0 : _a.applicantInfo) === null || _b === void 0 ? void 0 : _b.country) == 'USA' || ((_d = (_c = this.getCandidateDetails) === null || _c === void 0 ? void 0 : _c.applicantInfo) === null || _d === void 0 ? void 0 : _d.country) == null) {
                                this.getState("USA");
                                this.getCTC();
                            }
                            else {
                                this.getState("IND");
                                this.getINRctc();
                            }
                            this.generateViewCandidate();
                            if (((_g = (_f = (_e = this.getCandidateDetails) === null || _e === void 0 ? void 0 : _e.applicantInfo) === null || _f === void 0 ? void 0 : _f.file) === null || _g === void 0 ? void 0 : _g.length) || ((_h = this.getCandidateDetails) === null || _h === void 0 ? void 0 : _h.resumeName)) {
                                this.resumeflag = true;
                            }
                            else {
                                this.resumeflag = false;
                            }
                        }
                    }
                });
            }
        }
        else if (this.editFlowName == 'parsing_details') {
            this.subscription[this.subscription.length] = this.newTalentUploadService.getParsingDocValues().subscribe(data => {
                var _a, _b, _c, _d;
                if (data.details) {
                    this.getCandidateDetails = data.details || null;
                    if (this.getCandidateDetails) {
                        if (((_b = (_a = this.getCandidateDetails) === null || _a === void 0 ? void 0 : _a.candidateBasicDetails) === null || _b === void 0 ? void 0 : _b.country) == 'USA') {
                            this.getState("USA");
                            this.getCTC();
                        }
                        else {
                            this.getState("IND");
                            this.getINRctc();
                        }
                        this.getParsingDetails();
                        if ((_d = (_c = this.getCandidateDetails) === null || _c === void 0 ? void 0 : _c.fbUploadApplicantDocs) === null || _d === void 0 ? void 0 : _d.fileName) {
                            this.resumeflag = true;
                        }
                        else {
                            this.resumeflag = false;
                        }
                    }
                }
            });
        }
        else {
            this.getState("USA");
            this.getState("IND");
            this.getINRctc();
            this.getCTC();
            var educationarrayControl = this.talentDetailsForm.get("educations");
            var employmentDetails = this.talentDetailsForm.get("employmentDetails");
            educationarrayControl.push(this.createEducationview(this.educationDefaultvalue));
            employmentDetails.push(this.createEmployementview(this.employmentDefaultvalue));
        }
        this.primengConfig.ripple = true;
        this.talentDetailsForm.valueChanges.subscribe(e => {
            this.talentDetailsForm.setValue(e, { emitEvent: false });
        });
    }
    ngAfterViewInit() {
        // this.enableDirty()
    }
    /*  enableDirty(){
       this.subscription[this.subscription.length] = this.talentDetailsForm.statusChanges.subscribe(() => {
         if (this.talentDetailsForm.dirty) {
           this.store.dispatch(new MarkDirtyFormAction({
             dirty: true
           }));
         }
         else {
           this.store.dispatch(new MarkCleanFormAction({
             dirty: false
           }));
         }
       });
     } */
    getParsingDetails() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14;
        this.editDetailsFlag = true;
        var educationarrayControl = this.talentDetailsForm.get("educations");
        var employmentDetails = this.talentDetailsForm.get("employmentDetails");
        this.talentDetailsForm.get('basicDetails').get('firstName').setValue(((_b = (_a = this.getCandidateDetails) === null || _a === void 0 ? void 0 : _a.candidateBasicDetails) === null || _b === void 0 ? void 0 : _b.firstName) ? (_d = (_c = this.getCandidateDetails) === null || _c === void 0 ? void 0 : _c.candidateBasicDetails) === null || _d === void 0 ? void 0 : _d.firstName : "");
        this.talentDetailsForm.get('basicDetails').get('lastName').setValue(((_f = (_e = this.getCandidateDetails) === null || _e === void 0 ? void 0 : _e.candidateBasicDetails) === null || _f === void 0 ? void 0 : _f.lastName) ? (_h = (_g = this.getCandidateDetails) === null || _g === void 0 ? void 0 : _g.candidateBasicDetails) === null || _h === void 0 ? void 0 : _h.lastName : "");
        this.talentDetailsForm.get('basicDetails').get('middleName').setValue(((_k = (_j = this.getCandidateDetails) === null || _j === void 0 ? void 0 : _j.candidateBasicDetails) === null || _k === void 0 ? void 0 : _k.middleName) ? (_m = (_l = this.getCandidateDetails) === null || _l === void 0 ? void 0 : _l.candidateBasicDetails) === null || _m === void 0 ? void 0 : _m.middleName : "");
        this.talentDetailsForm.get('basicDetails').get('emailId').setValue(((_p = (_o = this.getCandidateDetails) === null || _o === void 0 ? void 0 : _o.candidateBasicDetails) === null || _p === void 0 ? void 0 : _p.emailId) ? (_r = (_q = this.getCandidateDetails) === null || _q === void 0 ? void 0 : _q.candidateBasicDetails) === null || _r === void 0 ? void 0 : _r.emailId : "");
        this.talentDetailsForm.get('basicDetails').get('contactNumber').setValue(((_t = (_s = this.getCandidateDetails) === null || _s === void 0 ? void 0 : _s.candidateBasicDetails) === null || _t === void 0 ? void 0 : _t.contactNumber) ? (_v = (_u = this.getCandidateDetails) === null || _u === void 0 ? void 0 : _u.candidateBasicDetails) === null || _v === void 0 ? void 0 : _v.contactNumber : "");
        this.talentDetailsForm.get('basicDetails').get('experience').setValue(((_x = (_w = this.getCandidateDetails) === null || _w === void 0 ? void 0 : _w.candidateBasicDetails) === null || _x === void 0 ? void 0 : _x.experience) ? (_z = (_y = this.getCandidateDetails) === null || _y === void 0 ? void 0 : _y.candidateBasicDetails) === null || _z === void 0 ? void 0 : _z.experience : "");
        this.talentDetailsForm.get('basicDetails').get('state').setValue(((_1 = (_0 = this.getCandidateDetails) === null || _0 === void 0 ? void 0 : _0.candidateBasicDetails) === null || _1 === void 0 ? void 0 : _1.state) ? (_3 = (_2 = this.getCandidateDetails) === null || _2 === void 0 ? void 0 : _2.candidateBasicDetails) === null || _3 === void 0 ? void 0 : _3.state : "");
        this.talentDetailsForm.get('basicDetails').get('country').setValue(((_5 = (_4 = this.getCandidateDetails) === null || _4 === void 0 ? void 0 : _4.candidateBasicDetails) === null || _5 === void 0 ? void 0 : _5.country) ? (_7 = (_6 = this.getCandidateDetails) === null || _6 === void 0 ? void 0 : _6.candidateBasicDetails) === null || _7 === void 0 ? void 0 : _7.country : "");
        if (((_9 = (_8 = this.getCandidateDetails) === null || _8 === void 0 ? void 0 : _8.candidateEducationDetails) === null || _9 === void 0 ? void 0 : _9.length) === 0 || ((_10 = this.getCandidateDetails) === null || _10 === void 0 ? void 0 : _10.candidateEducationDetails) === null) {
            educationarrayControl.push(this.createEducation(this.educationDefaultvalue));
        }
        else {
            (_11 = this.getCandidateDetails) === null || _11 === void 0 ? void 0 : _11.candidateEducationDetails.forEach((item) => {
                educationarrayControl.push(this.createParsingEducation(item));
            });
        }
        if (this.getCandidateDetails.candidateEmploymentDetails.length === 0 || this.getCandidateDetails.candidateEmploymentDetails === null) {
            employmentDetails.push(this.createEmployement(this.employmentDefaultvalue));
        }
        else {
            this.getCandidateDetails.candidateEmploymentDetails.forEach((item) => {
                employmentDetails.push(this.createEmployement(item));
            });
        }
        this.talentDetailsForm.get('basicDetails').get('skillsUsed').setValue(((_13 = (_12 = this.getCandidateDetails) === null || _12 === void 0 ? void 0 : _12.candidateBasicDetails) === null || _13 === void 0 ? void 0 : _13.skills) ? (_14 = this.getCandidateDetails.candidateBasicDetails) === null || _14 === void 0 ? void 0 : _14.skills.toString().split(",") : "");
        this.talentDetailsForm.get('employmentDetails').value.forEach((item, index) => {
            if (item.isCurrentEmployment == 1) {
                employmentDetails.at(index).get("endDateInYear").clearValidators();
                employmentDetails.at(index).get("endDateInMonth").clearValidators();
            }
            else {
                employmentDetails.at(index).get("endDateInYear").setValidators([Validators.required]);
                employmentDetails.at(index).get("endDateInMonth").setValidators([Validators.required]);
            }
        });
    }
    generateViewCandidate() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21;
        this.editDetailsFlag = true;
        var educationarrayControl = this.talentDetailsForm.get("educations");
        var employmentDetails = this.talentDetailsForm.get("employmentDetails");
        this.talentDetailsForm.get('basicDetails').get('firstName').setValue(((_b = (_a = this.getCandidateDetails) === null || _a === void 0 ? void 0 : _a.applicantInfo) === null || _b === void 0 ? void 0 : _b.firstName) ? (_d = (_c = this.getCandidateDetails) === null || _c === void 0 ? void 0 : _c.applicantInfo) === null || _d === void 0 ? void 0 : _d.firstName : "");
        this.talentDetailsForm.get('basicDetails').get('lastName').setValue(((_f = (_e = this.getCandidateDetails) === null || _e === void 0 ? void 0 : _e.applicantInfo) === null || _f === void 0 ? void 0 : _f.lastName) ? (_h = (_g = this.getCandidateDetails) === null || _g === void 0 ? void 0 : _g.applicantInfo) === null || _h === void 0 ? void 0 : _h.lastName : "");
        this.talentDetailsForm.get('basicDetails').get('middleName').setValue(((_k = (_j = this.getCandidateDetails) === null || _j === void 0 ? void 0 : _j.applicantInfo) === null || _k === void 0 ? void 0 : _k.middleName) ? (_m = (_l = this.getCandidateDetails) === null || _l === void 0 ? void 0 : _l.applicantInfo) === null || _m === void 0 ? void 0 : _m.middleName : "");
        this.talentDetailsForm.get('basicDetails').get('emailId').setValue(((_p = (_o = this.getCandidateDetails) === null || _o === void 0 ? void 0 : _o.applicantInfo) === null || _p === void 0 ? void 0 : _p.email) ? (_r = (_q = this.getCandidateDetails) === null || _q === void 0 ? void 0 : _q.applicantInfo) === null || _r === void 0 ? void 0 : _r.email : "");
        this.talentDetailsForm.get('basicDetails').get('contactNumber').setValue(((_t = (_s = this.getCandidateDetails) === null || _s === void 0 ? void 0 : _s.applicantInfo) === null || _t === void 0 ? void 0 : _t.phoneNo) ? (_v = (_u = this.getCandidateDetails) === null || _u === void 0 ? void 0 : _u.applicantInfo) === null || _v === void 0 ? void 0 : _v.phoneNo : "");
        this.talentDetailsForm.get('basicDetails').get('experience').setValue(((_x = (_w = this.getCandidateDetails) === null || _w === void 0 ? void 0 : _w.applicantInfo) === null || _x === void 0 ? void 0 : _x.experience) ? (_z = (_y = this.getCandidateDetails) === null || _y === void 0 ? void 0 : _y.applicantInfo) === null || _z === void 0 ? void 0 : _z.experience.toString() : "");
        this.talentDetailsForm.get('basicDetails').get('state').setValue(((_1 = (_0 = this.getCandidateDetails) === null || _0 === void 0 ? void 0 : _0.applicantInfo) === null || _1 === void 0 ? void 0 : _1.stateProvinceName) ? (_3 = (_2 = this.getCandidateDetails) === null || _2 === void 0 ? void 0 : _2.applicantInfo) === null || _3 === void 0 ? void 0 : _3.stateProvinceName : "");
        this.talentDetailsForm.get('basicDetails').get('status').setValue(((_5 = (_4 = this.getCandidateDetails) === null || _4 === void 0 ? void 0 : _4.applicantInfo) === null || _5 === void 0 ? void 0 : _5.applicantStatus.name) ? (_7 = (_6 = this.getCandidateDetails) === null || _6 === void 0 ? void 0 : _6.applicantInfo) === null || _7 === void 0 ? void 0 : _7.applicantStatus.name : "");
        this.talentDetailsForm.get('basicDetails').get('country').setValue(((_9 = (_8 = this.getCandidateDetails) === null || _8 === void 0 ? void 0 : _8.applicantInfo) === null || _9 === void 0 ? void 0 : _9.country) ? (_11 = (_10 = this.getCandidateDetails) === null || _10 === void 0 ? void 0 : _10.applicantInfo) === null || _11 === void 0 ? void 0 : _11.country : "");
        this.talentDetailsForm.get('basicDetails').get('skillsUsed').setValue(((_13 = (_12 = this.getCandidateDetails) === null || _12 === void 0 ? void 0 : _12.candidateBasicDetails) === null || _13 === void 0 ? void 0 : _13.skills) ? (_15 = (_14 = this.getCandidateDetails) === null || _14 === void 0 ? void 0 : _14.candidateBasicDetails) === null || _15 === void 0 ? void 0 : _15.skills.toString().split(",") : "");
        if (((_16 = this.getCandidateDetails) === null || _16 === void 0 ? void 0 : _16.educationList) !== null) {
            (_17 = this.getCandidateDetails) === null || _17 === void 0 ? void 0 : _17.educationList.forEach((item) => {
                educationarrayControl.push(this.createEducationview(item));
            });
        }
        else {
            educationarrayControl.push(this.createEducationview(this.educationDefaultvalue));
        }
        if (((_18 = this.getCandidateDetails) === null || _18 === void 0 ? void 0 : _18.employmentList) !== null) {
            (_19 = this.getCandidateDetails) === null || _19 === void 0 ? void 0 : _19.employmentList.forEach((item) => {
                employmentDetails.push(this.createEmployementview(item));
            });
        }
        else {
            employmentDetails.push(this.createEmployementview(this.employmentDefaultvalue));
        }
        this.talentDetailsForm.get('employmentDetails').value.forEach((item, index) => {
            if (item.isCurrentEmployment == 1) {
                employmentDetails.at(index).get("endDateInYear").clearValidators();
                employmentDetails.at(index).get("endDateInMonth").clearValidators();
            }
            else {
                employmentDetails.at(index).get("endDateInYear").setValidators([Validators.required]);
                employmentDetails.at(index).get("endDateInMonth").setValidators([Validators.required]);
            }
        });
        this.fileFormat = (_21 = (_20 = this.getCandidateDetails) === null || _20 === void 0 ? void 0 : _20.applicantInfo) === null || _21 === void 0 ? void 0 : _21.file[0].fileType;
    }
    generateCandidate() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
        this.editDetailsFlag = true;
        var educationarrayControl = this.talentDetailsForm.get("educations");
        var employmentDetails = this.talentDetailsForm.get("employmentDetails");
        this.talentDetailsForm.get('basicDetails').get('firstName').setValue(((_a = this.getCandidateDetails) === null || _a === void 0 ? void 0 : _a.firstName) ? (_b = this.getCandidateDetails) === null || _b === void 0 ? void 0 : _b.firstName : "");
        this.talentDetailsForm.get('basicDetails').get('lastName').setValue(((_c = this.getCandidateDetails) === null || _c === void 0 ? void 0 : _c.lastName) ? (_d = this.getCandidateDetails) === null || _d === void 0 ? void 0 : _d.lastName : "");
        this.talentDetailsForm.get('basicDetails').get('middleName').setValue(((_e = this.getCandidateDetails) === null || _e === void 0 ? void 0 : _e.middleName) ? (_f = this.getCandidateDetails) === null || _f === void 0 ? void 0 : _f.middleName : "");
        this.talentDetailsForm.get('basicDetails').get('emailId').setValue(((_g = this.getCandidateDetails) === null || _g === void 0 ? void 0 : _g.email) ? (_h = this.getCandidateDetails) === null || _h === void 0 ? void 0 : _h.email : "");
        this.talentDetailsForm.get('basicDetails').get('contactNumber').setValue(((_j = this.getCandidateDetails) === null || _j === void 0 ? void 0 : _j.phoneNo) ? (_k = this.getCandidateDetails) === null || _k === void 0 ? void 0 : _k.phoneNo : "");
        this.talentDetailsForm.get('basicDetails').get('experience').setValue(((_l = this.getCandidateDetails) === null || _l === void 0 ? void 0 : _l.experience) ? (_m = this.getCandidateDetails) === null || _m === void 0 ? void 0 : _m.experience : "");
        this.talentDetailsForm.get('basicDetails').get('state').setValue(((_p = (_o = this.getCandidateDetails) === null || _o === void 0 ? void 0 : _o.applicantInfo) === null || _p === void 0 ? void 0 : _p.stateProvinceName) ? (_r = (_q = this.getCandidateDetails) === null || _q === void 0 ? void 0 : _q.applicantInfo) === null || _r === void 0 ? void 0 : _r.stateProvinceName.toString() : "");
        this.talentDetailsForm.get('basicDetails').get('status').setValue(((_t = (_s = this.getCandidateDetails) === null || _s === void 0 ? void 0 : _s.applicantInfo) === null || _t === void 0 ? void 0 : _t.applicantStatus.name) ? (_v = (_u = this.getCandidateDetails) === null || _u === void 0 ? void 0 : _u.applicantInfo) === null || _v === void 0 ? void 0 : _v.applicantStatus.name : "");
        this.talentDetailsForm.get('basicDetails').get('country').setValue(((_x = (_w = this.getCandidateDetails) === null || _w === void 0 ? void 0 : _w.applicantInfo) === null || _x === void 0 ? void 0 : _x.country) ? (_z = (_y = this.getCandidateDetails) === null || _y === void 0 ? void 0 : _y.applicantInfo) === null || _z === void 0 ? void 0 : _z.country.toString() : "");
        this.talentDetailsForm.get('basicDetails').get('skillsUsed').setValue(((_1 = (_0 = this.getCandidateDetails) === null || _0 === void 0 ? void 0 : _0.candidateBasicDetails) === null || _1 === void 0 ? void 0 : _1.skills) ? (_3 = (_2 = this.getCandidateDetails) === null || _2 === void 0 ? void 0 : _2.candidateBasicDetails) === null || _3 === void 0 ? void 0 : _3.skills.toString().split(",") : "");
        this.getCandidateDetails.fbApplicantEducation.forEach((item) => {
            educationarrayControl.push(this.createEducation(item));
        });
        this.getCandidateDetails.fbApplicantEmployment.forEach((item) => {
            employmentDetails.push(this.createEmployement(item));
        });
        this.talentDetailsForm.get('employmentDetails').value.forEach((item, index) => {
            if (item.isCurrentEmployment == 1) {
                employmentDetails.at(index).get("endDateInYear").clearValidators();
                employmentDetails.at(index).get("endDateInMonth").clearValidators();
            }
            else {
                employmentDetails.at(index).get("endDateInYear").setValidators([Validators.required]);
                employmentDetails.at(index).get("endDateInMonth").setValidators([Validators.required]);
            }
        });
        const format = (_5 = (_4 = this.getCandidateDetails) === null || _4 === void 0 ? void 0 : _4.resumeName) === null || _5 === void 0 ? void 0 : _5.split(".");
        this.fileFormat = format[1];
    }
    getCTC() {
        this.subscription[this.subscription.length] = this.talentEditDetailsService.getCTC()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.ctcValues = response.data;
        });
    }
    getINRctc() {
        this.subscription[this.subscription.length] = this.talentEditDetailsService.getINRctc()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.ctcValues = response.data;
        });
    }
    getNP() {
        this.subscription[this.subscription.length] = this.talentEditDetailsService.getNoticePeriod()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.getNPValues = response.data;
        });
    }
    getJoiningMonth() {
        this.subscription[this.subscription.length] = this.talentEditDetailsService.getJoiningMonth()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.getJoiningMonths = response.data;
        });
    }
    getQualification() {
        this.subscription[this.subscription.length] = this.talentEditDetailsService.getQualification()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.qualifications = response.data;
        });
    }
    getExperienceYear() {
        this.subscription[this.subscription.length] = this.talentEditDetailsService.getExperienceYear()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.experienceYear = response.data;
        });
    }
    getExperienceMonth() {
        this.subscription[this.subscription.length] = this.talentEditDetailsService.getExperienceMonth()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.experienceMonth = response.data;
        });
    }
    getCourseStartingYear() {
        this.subscription[this.subscription.length] = this.talentEditDetailsService.getStartingYear()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.courseStartingYears = response.data;
        });
    }
    getCourseStartingMonth() {
        this.subscription[this.subscription.length] = this.talentEditDetailsService.getJoiningMonth()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.courseStartingYears = response.data;
        });
    }
    getEmploymentType() {
        this.subscription[this.subscription.length] = this.talentEditDetailsService.getEmploymentType()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.employmentTypes = response.data;
        });
    }
    getCountry() {
        this.subscription[this.subscription.length] = this.talentEditDetailsService.getCountries()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.countries = response.data.filter(data => {
                return data.code == "USA" || data.code == "IND";
            });
        });
    }
    onCountryChange(data) {
        this.getState(data.value);
        if (data.value == "IND") {
            this.getINRctc();
        }
        else {
            this.getCTC();
        }
    }
    onStatusChange(data) {
        let status = this.getStatusDetails.filter(x => x.name == data.value);
        this.talentDetailsForm.get('basicDetails').get('status').setValue(status[0].name);
        this.setStatus = status[0];
    }
    onStateChange(data) {
        let state = this.states.filter(x => x.name == data.value);
        this.talentDetailsForm.get('basicDetails').get('state').setValue(state[0].name);
    }
    getState(code) {
        this.subscription[this.subscription.length] = this.talentEditDetailsService.getStates(code)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response === null || response === void 0 ? void 0 : response.data) {
                this.states = response.data;
            }
        });
    }
    getJobType() {
        this.subscription[this.subscription.length] = this.talentEditDetailsService.getJobType()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.jobTypes = response.data;
        });
    }
    getJobCategory() {
        this.subscription[this.subscription.length] = this.talentEditDetailsService.getJobCategory()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.jobCategory = response.data;
        });
    }
    getSpecialization() {
        this.subscription[this.subscription.length] = this.talentEditDetailsService.getSpecialization()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.specializations = response.data;
        });
    }
    getCourseType() {
        this.subscription[this.subscription.length] = this.talentEditDetailsService.getCourseType()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.courseType = response.data;
        });
    }
    getCourse() {
        this.subscription[this.subscription.length] = this.talentEditDetailsService.getCourse()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.courses = response.data;
        });
    }
    getStatus() {
        this.subscription[this.subscription.length] = this.talentEditDetailsService.getApplicantStatus()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                this.getStatusDetails = response.data;
            }
        });
    }
    createEducation(item) {
        return this.fb.group({
            applicantInfoId: [Number([item.applicantInfoId]), [Validators.required]],
            courseEndYear: [item.courseEndYear != undefined && item.courseEndYear != '' ? String(item.courseEndYear) : '', [Validators.required]],
            courseId: [item.courseId != undefined && item.courseId != '' ? Number(item.courseId) : '', [Validators.required]],
            courseTypeId: [item.courseTypeId ? Number(item.courseTypeId) : '', [Validators.required]],
            courseStartYear: [item.courseStartYear != undefined && item.courseStartYear != '' ? String(item.courseStartYear) : '', [Validators.required]],
            createdDate: [item.createdDate = new Date()],
            educationId: [item.educationId != undefined && item.educationId != '' ? Number(item.educationId) : '', [Validators.required]],
            id: Number([item.id = 0]),
            universityName: [item.universityName, [Validators.required]],
            specializationId: [item.specialization != undefined && item.specializationId != '' ? Number(item.specialization.id) : '', [Validators.required]],
        });
    }
    createEmployement(item) {
        return this.fb.group({
            applicantInfoId: Number([item.applicantInfoId]),
            companyName: [item.companyName],
            createdDate: [item.createdDate = new Date()],
            ctcId: [item.ctc != undefined && item.ctc != '' ? String(item.ctc.code) : ''],
            designation: [item.designation],
            employmentTypeId: ([item.employmentType != undefined && item.employmentType != '' ? String(item.employmentType.id) : '']),
            id: [item.id = 0],
            isCurrentEmployment: [item.isCurrentEmployment == 1 ? 1 : 0],
            jobRolesAndRespon: [item.jobRolesAndRespon],
            joiningDateInMonth: [item.joiningDateInMonth],
            joiningDateInYear: [item.joiningDateInYear],
            endDateInMonth: [item.endDateInMonth],
            endDateInYear: [item.endDateInYear],
            noticePeriod: [item.noticePeriod],
            skillsUsed: [item.skillsUsed],
            totalExperienceInMonths: [item.totalExperienceInMonths],
            totalExperienceInYears: [item.totalExperienceInYears],
        });
    }
    createEducationview(item) {
        var _a, _b, _c, _d;
        return this.fb.group({
            applicantInfoId: [Number([item.applicantInfoId]), [Validators.required]],
            courseEndYear: [item.courseEndYear != undefined && item.courseEndYear != '' ? String(item.courseEndYear) : '', [Validators.required]],
            courseId: [item.course != undefined && item.courseId != '' ? String((item === null || item === void 0 ? void 0 : item.courseId) ? item.courseId : item === null || item === void 0 ? void 0 : item.course.id) : '', [Validators.required]],
            courseTypeId: [item.courseType != undefined && item.courseTypeId != '' ? String((item === null || item === void 0 ? void 0 : item.courseType) ? (_a = item.courseType) === null || _a === void 0 ? void 0 : _a.id : item === null || item === void 0 ? void 0 : item.courseTypeId) : '', [Validators.required]],
            courseStartYear: [item.courseStartYear != undefined && item.courseStartYear != '' ? String(item === null || item === void 0 ? void 0 : item.courseStartYear) : '', [Validators.required]],
            createdDate: [item.createdDate = new Date()],
            educationId: [item.education != undefined && item.educationId != '' ? String((item === null || item === void 0 ? void 0 : item.educationId) ? item === null || item === void 0 ? void 0 : item.educationId : (_b = item === null || item === void 0 ? void 0 : item.education) === null || _b === void 0 ? void 0 : _b.id) : '', [Validators.required]],
            id: Number([item.id]),
            universityName: [(item === null || item === void 0 ? void 0 : item.universityName) ? item === null || item === void 0 ? void 0 : item.universityName : "", [Validators.required]],
            specializationId: [item.specialization != undefined && item.specializationId != '' ? String(((_c = item.specialization) === null || _c === void 0 ? void 0 : _c.id) ? (_d = item.specialization) === null || _d === void 0 ? void 0 : _d.id : item.specializationId) : '', [Validators.required]],
        });
    }
    createParsingEducation(item) {
        return this.fb.group({
            applicantInfoId: [Number([(item === null || item === void 0 ? void 0 : item.applicantInfoId) ? item === null || item === void 0 ? void 0 : item.applicantInfoId : 0]), [Validators.required]],
            courseEndYear: [(item === null || item === void 0 ? void 0 : item.endYear) != undefined && (item === null || item === void 0 ? void 0 : item.endYear) != '' ? String(item === null || item === void 0 ? void 0 : item.endYear) : '', [Validators.required]],
            courseId: [(item === null || item === void 0 ? void 0 : item.course) != undefined && (item === null || item === void 0 ? void 0 : item.course) != '' ? String((item === null || item === void 0 ? void 0 : item.course) ? item === null || item === void 0 ? void 0 : item.course : item === null || item === void 0 ? void 0 : item.course.id) : '', [Validators.required]],
            courseTypeId: [(item === null || item === void 0 ? void 0 : item.courseType) != undefined && (item === null || item === void 0 ? void 0 : item.courseType) != '' ? String((item === null || item === void 0 ? void 0 : item.courseType) ? item === null || item === void 0 ? void 0 : item.courseType : "") : '', [Validators.required]],
            courseStartYear: [(item === null || item === void 0 ? void 0 : item.startYear) != undefined && item.startYear != '' ? String((item === null || item === void 0 ? void 0 : item.startYear) ? item === null || item === void 0 ? void 0 : item.startYear : '') : '', [Validators.required]],
            createdDate: [new Date((item === null || item === void 0 ? void 0 : item.createdDate) ? item === null || item === void 0 ? void 0 : item.createdDate : "")],
            educationId: [(item === null || item === void 0 ? void 0 : item.education) != undefined && (item === null || item === void 0 ? void 0 : item.education) != '' ? String((item === null || item === void 0 ? void 0 : item.education) ? item === null || item === void 0 ? void 0 : item.education : '') : '', [Validators.required]],
            id: Number([(item === null || item === void 0 ? void 0 : item.id) ? item.id : 0]),
            universityName: [(item === null || item === void 0 ? void 0 : item.university) != undefined && (item === null || item === void 0 ? void 0 : item.university) != '' ? item === null || item === void 0 ? void 0 : item.university : '', [Validators.required]],
            specializationId: [(item === null || item === void 0 ? void 0 : item.specialisation) != undefined && (item === null || item === void 0 ? void 0 : item.specialisation) != '' ? String((item === null || item === void 0 ? void 0 : item.specialisation) ? item === null || item === void 0 ? void 0 : item.specialisation : '') : '', [Validators.required]],
        });
    }
    createEmployementview(item) {
        var _a, _b;
        return this.fb.group({
            applicantInfoId: [Number((item === null || item === void 0 ? void 0 : item.applicantInfoId) ? item.applicantInfoId : 0)],
            companyName: [(item === null || item === void 0 ? void 0 : item.companyName) ? item === null || item === void 0 ? void 0 : item.companyName : ""],
            createdDate: [item.createdDate = new Date()],
            ctcId: ([item.ctc != undefined && item.ctc != '' ? String((_a = item.ctc) === null || _a === void 0 ? void 0 : _a.id) : item.ctcId]),
            designation: [(item === null || item === void 0 ? void 0 : item.designation) ? item === null || item === void 0 ? void 0 : item.designation : ""],
            employmentTypeId: ([item.employmentType != undefined && item.employmentType != '' ? String(item.employmentType.id) : '']),
            id: [Number((item === null || item === void 0 ? void 0 : item.id) ? item.id : 0)],
            isCurrentEmployment: [(item === null || item === void 0 ? void 0 : item.isCurrentEmployment) == 1 ? 1 : 0],
            jobRolesAndRespon: [(item === null || item === void 0 ? void 0 : item.jobRolesAndRespon) ? item === null || item === void 0 ? void 0 : item.jobRolesAndRespon : ""],
            joiningDateInMonth: [(item === null || item === void 0 ? void 0 : item.joiningDateInMonth) ? item === null || item === void 0 ? void 0 : item.joiningDateInMonth : ""],
            joiningDateInYear: [(item === null || item === void 0 ? void 0 : item.joiningDateInYear) ? item.joiningDateInYear : ""],
            endDateInMonth: [(item === null || item === void 0 ? void 0 : item.endDateInMonth) ? item.endDateInMonth : ""],
            endDateInYear: [(item === null || item === void 0 ? void 0 : item.endDateInYear) ? item.endDateInYear : ""],
            noticePeriod: [(item === null || item === void 0 ? void 0 : item.noticePeriod) ? item.noticePeriod : ""],
            skillsUsed: [(_b = item === null || item === void 0 ? void 0 : item.skillsUsed) === null || _b === void 0 ? void 0 : _b.toString().split(",")],
            totalExperienceInMonths: [(item === null || item === void 0 ? void 0 : item.totalExperienceInMonths) ? item.totalExperienceInMonths : ""],
            totalExperienceInYears: [(item === null || item === void 0 ? void 0 : item.totalExperienceInYears) ? item.totalExperienceInYears : ""],
        });
    }
    get f() {
        return this.talentDetailsForm.get('basicDetails')['controls'];
    }
    get fEducation() {
        return this.talentDetailsForm.get('educations')['controls'];
    }
    get fEmployment() {
        return this.talentDetailsForm.get('employmentDetails')['controls'];
    }
    get educations() {
        return this.talentDetailsForm.get('educations');
    }
    removeEducation(i) {
        const remove = this.talentDetailsForm.get('educations');
        remove.removeAt(i);
    }
    addEducation() {
        this.educations.push(this.createEducation(this.educationDefaultvalue));
    }
    get employmentDetails() {
        return this.talentDetailsForm.get('employmentDetails');
    }
    removeEmployment(i) {
        const remove = this.talentDetailsForm.get('employmentDetails');
        remove.removeAt(i);
    }
    addEmployement() {
        this.employmentDetails.push(this.createEmployement(this.employmentDefaultvalue));
    }
    handleIsCurrentEmployement(value, index) {
        var employmentDetailscontrol = this.talentDetailsForm.get("employmentDetails");
        if (value == "Yes") {
            employmentDetailscontrol.at(index).get("endDateInYear").clearValidators();
            employmentDetailscontrol.at(index).get("endDateInMonth").clearValidators();
        }
        else {
            employmentDetailscontrol.at(index).get("endDateInYear").setValidators([Validators.required]);
            employmentDetailscontrol.at(index).get("endDateInMonth").setValidators([Validators.required]);
        }
    }
    onSkillsAdd(skill) {
        this.skillArray.push(skill.value);
    }
    skillRemove(skill) {
        this.skillArray.forEach((item, i) => {
            if (skill.value == item) {
                this.skillArray.splice(i, 1);
            }
        });
    }
    deleteConfirm(data, i) {
        this.displayBasic = true;
        this.getDeleteDoc = data;
    }
    deleteBulkFileConfirm() {
        this.displayBasic = true;
        this.resumeflag = false;
    }
    viewResume(data) {
        const path = environment.docs + data.fileLocation.replace('/var/imagility/uploads/', '');
        window.open(`${path}`, "_blank");
    }
    viewBulkResume() {
        var _a, _b, _c, _d;
        const path = environment.docs + ((_a = this.getCandidateDetails) === null || _a === void 0 ? void 0 : _a.resumeFilePath) ? (_b = this.getCandidateDetails) === null || _b === void 0 ? void 0 : _b.resumeFilePath.replace('/var/imagility/uploads/', '') : (_d = (_c = this.getCandidateDetails) === null || _c === void 0 ? void 0 : _c.fbUploadApplicantDocs) === null || _d === void 0 ? void 0 : _d.fileName.replace('/var/imagility/uploads/', '');
        window.open(`${path}`, "_blank");
    }
    DownloadResume(data) {
        const path = environment.docs + data.fileLocation.replace('/var/imagility/uploads/', '');
        if (data.fileFormat == 'pdf') {
            this.talentEditDetailsService.downloadDocuments(path, "Resume");
        }
        else {
            window.open(`${path}`, "_blank");
        }
    }
    DownloadBulkResume() {
        var _a, _b, _c, _d;
        const path = environment.docs + ((_a = this.getCandidateDetails) === null || _a === void 0 ? void 0 : _a.resumeFilePath) ? (_b = this.getCandidateDetails) === null || _b === void 0 ? void 0 : _b.resumeFilePath.replace('/var/imagility/uploads/', '') : (_d = (_c = this.getCandidateDetails) === null || _c === void 0 ? void 0 : _c.fbUploadApplicantDocs) === null || _d === void 0 ? void 0 : _d.fileName.replace('/var/imagility/uploads/', '');
        if (this.fileFormat == 'pdf') {
            this.talentEditDetailsService.downloadDocuments(path, "Resume");
        }
        else {
            window.open(`${path}`, "_blank");
        }
    }
    deleteResume() {
        if (this.getErrorID) {
            this.subscription[this.subscription.length] = this.talentEditDetailsService.deleteResume(this.getErrorID)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                if (response) {
                    this.displayBasic = false;
                    this.backToParentPage();
                }
            });
        }
        else {
            this.subscription[this.subscription.length] = this.talentEditDetailsService.delete(this.getDeleteDoc.id)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                if (response.data == null) {
                    this.displayBasic = false;
                    this.getCandidateDetails.applicantInfo.file.forEach((item, i) => {
                        if (this.getDeleteDoc.id == item.id) {
                            return this.getCandidateDetails.applicantInfo.file.splice(i, 1);
                        }
                    });
                }
            });
        }
    }
    saveTalentData() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45;
        this.submitted = true;
        this.isValidFormSubmitted = false;
        if (this.talentDetailsForm.invalid) {
            return;
        }
        let employeementdetail = [];
        let educationdetail = [];
        this.talentDetailsForm.get('employmentDetails').value.forEach((item) => {
            var _a;
            item.skillsUsed = (_a = item.skillsUsed) === null || _a === void 0 ? void 0 : _a.toString();
            let formatedProvinceData = {};
            for (const property in item) {
                const unusedObjectValues = ["companyName", "createdDate", "designation", "jobRolesAndRespon", "joiningDateInYear", "endDateInMonth", "endDateInYear", "noticePeriod", "totalExperienceInMonths", "totalExperienceInYears", "joiningDateInMonth", "skillsUsed"];
                formatedProvinceData = unusedObjectValues.includes(property)
                    ? Object.assign(Object.assign({}, formatedProvinceData), { [property]: item[property] }) : Object.assign(Object.assign({}, formatedProvinceData), { [property]: parseFloat(item[property]) });
            }
            employeementdetail.push(formatedProvinceData);
        });
        this.talentDetailsForm.get('educations').value.forEach((item) => {
            let formatedProvinceData = {};
            for (const property in item) {
                const unusedObjectValues = ["universityName", "createdDate"];
                formatedProvinceData = unusedObjectValues.includes(property)
                    ? Object.assign(Object.assign({}, formatedProvinceData), { [property]: item[property] }) : Object.assign(Object.assign({}, formatedProvinceData), { [property]: parseFloat(item[property]) });
            }
            educationdetail.push(formatedProvinceData);
        });
        this.getCompanyId = sessionStorage.getItem('companyId');
        this.sourceInfo = JSON.parse(sessionStorage.getItem("getSourceValue"));
        this.supplierId = JSON.parse(sessionStorage.getItem("getSupplierValue"));
        this.supplierName = JSON.parse(sessionStorage.getItem("getSupplierNameValue"));
        if (this.editFlowName == 'bulk') {
            this.payload = {
                "id": ((_a = this.getCandidateDetails) === null || _a === void 0 ? void 0 : _a.id) ? (_b = this.getCandidateDetails) === null || _b === void 0 ? void 0 : _b.id : 0,
                "jobPositionId": ((_c = this.getCandidateDetails) === null || _c === void 0 ? void 0 : _c.jobPositionId) ? (_d = this.getCandidateDetails) === null || _d === void 0 ? void 0 : _d.jobPositionId : null,
                "jobCode": ((_e = this.getCandidateDetails) === null || _e === void 0 ? void 0 : _e.jobCode) ? (_f = this.getCandidateDetails) === null || _f === void 0 ? void 0 : _f.jobCode : null,
                "firstName": this.talentDetailsForm.get('basicDetails').get('firstName').value,
                "middleName": this.talentDetailsForm.get('basicDetails').get('middleName').value,
                "lastName": this.talentDetailsForm.get('basicDetails').get('lastName').value,
                "email": this.talentDetailsForm.get('basicDetails').get('emailId').value,
                "phoneNo": this.talentDetailsForm.get('basicDetails').get('contactNumber').value,
                "experience": this.talentDetailsForm.get('basicDetails').get('experience').value,
                "skills": this.talentDetailsForm.get('basicDetails').get('skillsUsed').value,
                "supplierId": this.supplierId,
                "supplierName": this.supplierName,
                "applicantStatus": {
                    "code": "APPLIED",
                    "createdBy": 1,
                    "description": "Applicant Status",
                    "group": "APPLICANTSTATUS",
                    "id": 2116,
                    "isVisible": 1,
                    "modifiedBy": 0,
                    "name": "Applied",
                    "refGroupdesc": "Applied"
                },
                "sourceName": ((_g = this.getCandidateDetails) === null || _g === void 0 ? void 0 : _g.sourceName) ? (_h = this.getCandidateDetails) === null || _h === void 0 ? void 0 : _h.sourceName : "",
                "resumeName": ((_j = this.getCandidateDetails) === null || _j === void 0 ? void 0 : _j.resumeName) ? (_k = this.getCandidateDetails) === null || _k === void 0 ? void 0 : _k.resumeName : "",
                "fbApplicantEducation": educationdetail,
                "fbApplicantEmployment": employeementdetail,
                "createdDate": new Date(),
                "applicantSourceRefCode": "TALENTPOOL",
                "applicantSourceInputType": "BULKUPLOAD",
                "country": ((_l = this.getCandidateDetails) === null || _l === void 0 ? void 0 : _l.country) ? (_m = this.getCandidateDetails) === null || _m === void 0 ? void 0 : _m.country : this.talentDetailsForm.get('basicDetails').get('country').value,
                "stateProvinceName": ((_o = this.getCandidateDetails) === null || _o === void 0 ? void 0 : _o.stateProvinceName) ? (_p = this.getCandidateDetails) === null || _p === void 0 ? void 0 : _p.stateProvinceName : this.talentDetailsForm.get('basicDetails').get('state').value,
            };
        }
        /*  else if (this.editFlowName == 'view_candidate' || this.candidateId != null || this.editFlowName == 'view_acquisition_candidate' || this.editFlowName == 'parsing_details') { */
        else if (this.candidateId != null || this.editFlowName == 'view_acquisition_candidate') {
            let jobPositionId = Number(sessionStorage.getItem('selectedjobposition'));
            this.payload = {
                "applicantSourceRefCode": "TALENTPOOL",
                "applicantSourceInputType": "TP_APP_INDIVIDUAL",
                "applicantStatus": this.setStatus ? this.setStatus : {
                    "code": "APPLIED",
                    "createdBy": 1,
                    "description": "Applicant Status",
                    "group": "APPLICANTSTATUS",
                    "id": 2116,
                    "isVisible": 1,
                    "modifiedBy": 0,
                    "name": "Applied",
                    "refGroupdesc": "Applied"
                },
                "createdDate": new Date(),
                "skillsUsed": (this.talentDetailsForm.get('basicDetails').get('skillsUsed').value).toString(),
                "email": this.talentDetailsForm.get('basicDetails').get('emailId').value,
                "fbApplicantEducation": educationdetail,
                "fbApplicantEmployment": employeementdetail,
                "firstName": this.talentDetailsForm.get('basicDetails').get('firstName').value,
                "id": ((_r = (_q = this.getCandidateDetails) === null || _q === void 0 ? void 0 : _q.employmentList[0]) === null || _r === void 0 ? void 0 : _r.applicantInfoId) ? (_t = (_s = this.getCandidateDetails) === null || _s === void 0 ? void 0 : _s.employmentList[0]) === null || _t === void 0 ? void 0 : _t.applicantInfoId : 0,
                "jobPositionId": ((_v = (_u = this.getCandidateDetails) === null || _u === void 0 ? void 0 : _u.applicantInfo) === null || _v === void 0 ? void 0 : _v.jobPositionId) ? (_x = (_w = this.getCandidateDetails) === null || _w === void 0 ? void 0 : _w.applicantInfo) === null || _x === void 0 ? void 0 : _x.jobPositionId : jobPositionId,
                "jobCode": ((_z = (_y = this.getCandidateDetails) === null || _y === void 0 ? void 0 : _y.applicantInfo) === null || _z === void 0 ? void 0 : _z.jobCode) ? (_1 = (_0 = this.getCandidateDetails) === null || _0 === void 0 ? void 0 : _0.applicantInfo) === null || _1 === void 0 ? void 0 : _1.jobCode : null,
                "middleName": this.talentDetailsForm.get('basicDetails').get('middleName').value,
                "lastName": this.talentDetailsForm.get('basicDetails').get('lastName').value,
                "phoneNo": this.talentDetailsForm.get('basicDetails').get('contactNumber').value,
                "experience": this.talentDetailsForm.get('basicDetails').get('experience').value,
                "sourceName": ((_3 = (_2 = this.getCandidateDetails) === null || _2 === void 0 ? void 0 : _2.applicantInfo) === null || _3 === void 0 ? void 0 : _3.sourceName) ? (_5 = (_4 = this.getCandidateDetails) === null || _4 === void 0 ? void 0 : _4.applicantInfo) === null || _5 === void 0 ? void 0 : _5.sourceName : "",
                "resumeName": ((_7 = (_6 = this.getCandidateDetails) === null || _6 === void 0 ? void 0 : _6.applicantInfo) === null || _7 === void 0 ? void 0 : _7.resumeName) ? (_9 = (_8 = this.getCandidateDetails) === null || _8 === void 0 ? void 0 : _8.applicantInfo) === null || _9 === void 0 ? void 0 : _9.resumeName : "",
                "stateProvinceName": this.talentDetailsForm.get('basicDetails').get('state').value,
                "country": this.talentDetailsForm.get('basicDetails').get('country').value,
                "companyId": this.getCompanyId,
                "applicantSourceRefName": ((_11 = (_10 = this.getCandidateDetails) === null || _10 === void 0 ? void 0 : _10.applicantInfo) === null || _11 === void 0 ? void 0 : _11.applicantSourceRefName) ? (_13 = (_12 = this.getCandidateDetails) === null || _12 === void 0 ? void 0 : _12.applicantInfo) === null || _13 === void 0 ? void 0 : _13.applicantSourceRefName : (_14 = this.sourceInfo) === null || _14 === void 0 ? void 0 : _14.name,
            };
        }
        else if (this.editFlowName == 'parsing_details') {
            let jobPositionId = sessionStorage.getItem('selectedjobposition');
            this.payload = {
                "applicantSourceRefCode": "TALENTPOOL",
                "applicantSourceInputType": "TP_APP_INDIVIDUAL",
                "applicantSourceId": (_15 = this.sourceInfo) === null || _15 === void 0 ? void 0 : _15.id,
                "applicantSourceRefName": (_16 = this.sourceInfo) === null || _16 === void 0 ? void 0 : _16.name,
                "supplierId": this.supplierId,
                "supplierName": this.supplierName,
                "applicantStatus": this.setStatus ? this.setStatus : {
                    "code": "APPLIED",
                    "createdBy": 1,
                    "description": "Applicant Status",
                    "group": "APPLICANTSTATUS",
                    "id": 2116,
                    "isVisible": 1,
                    "modifiedBy": 0,
                    "name": "Applied",
                    "refGroupdesc": "Applied"
                },
                "createdDate": new Date(),
                "skillsUsed": (this.talentDetailsForm.get('basicDetails').get('skillsUsed').value).toString(),
                "email": this.talentDetailsForm.get('basicDetails').get('emailId').value,
                "fbApplicantEducation": educationdetail,
                "fbApplicantEmployment": employeementdetail,
                "firstName": this.talentDetailsForm.get('basicDetails').get('firstName').value,
                "id": 0,
                "jobPositionId": jobPositionId,
                "jobCode": null,
                "companyId": this.getCompanyId,
                "middleName": this.talentDetailsForm.get('basicDetails').get('middleName').value,
                "lastName": this.talentDetailsForm.get('basicDetails').get('lastName').value,
                "phoneNo": this.talentDetailsForm.get('basicDetails').get('contactNumber').value,
                "experience": this.talentDetailsForm.get('basicDetails').get('experience').value,
                "sourceName": "",
                "resumeName": ((_18 = (_17 = this.getCandidateDetails) === null || _17 === void 0 ? void 0 : _17.fbUploadApplicantDocs) === null || _18 === void 0 ? void 0 : _18.fileName) ? (_20 = (_19 = this.getCandidateDetails) === null || _19 === void 0 ? void 0 : _19.fbUploadApplicantDocs) === null || _20 === void 0 ? void 0 : _20.fileName : "",
                "stateProvinceName": this.talentDetailsForm.get('basicDetails').get('state').value,
                "country": this.talentDetailsForm.get('basicDetails').get('country').value,
            };
        }
        else {
            const source = Object.assign({}, JSON.parse(sessionStorage.getItem("getSourceValue")));
            const filename = sessionStorage.getItem("uploadedFileName");
            this.payload = {
                "id": 0,
                "jobPositionId": ((_22 = (_21 = this.getCandidateDetails) === null || _21 === void 0 ? void 0 : _21.applicantInfo) === null || _22 === void 0 ? void 0 : _22.jobPositionId) ? (_24 = (_23 = this.getCandidateDetails) === null || _23 === void 0 ? void 0 : _23.applicantInfo) === null || _24 === void 0 ? void 0 : _24.jobPositionId : null,
                "jobCode": ((_26 = (_25 = this.getCandidateDetails) === null || _25 === void 0 ? void 0 : _25.applicantInfo) === null || _26 === void 0 ? void 0 : _26.jobCode) ? (_28 = (_27 = this.getCandidateDetails) === null || _27 === void 0 ? void 0 : _27.applicantInfo) === null || _28 === void 0 ? void 0 : _28.jobCode : null,
                "firstName": this.talentDetailsForm.get('basicDetails').get('firstName').value,
                "middleName": this.talentDetailsForm.get('basicDetails').get('middleName').value,
                "lastName": this.talentDetailsForm.get('basicDetails').get('lastName').value,
                "email": this.talentDetailsForm.get('basicDetails').get('emailId').value,
                "phoneNo": this.talentDetailsForm.get('basicDetails').get('contactNumber').value,
                "experience": this.talentDetailsForm.get('basicDetails').get('experience').value,
                "applicantStatus": source,
                "supplierId": this.supplierId,
                "sourceName": ((_30 = (_29 = this.getCandidateDetails) === null || _29 === void 0 ? void 0 : _29.applicantInfo) === null || _30 === void 0 ? void 0 : _30.sourceName) ? (_32 = (_31 = this.getCandidateDetails) === null || _31 === void 0 ? void 0 : _31.applicantInfo) === null || _32 === void 0 ? void 0 : _32.sourceName : source.name,
                "resumeName": ((_34 = (_33 = this.getCandidateDetails) === null || _33 === void 0 ? void 0 : _33.applicantInfo) === null || _34 === void 0 ? void 0 : _34.resumeName) ? (_36 = (_35 = this.getCandidateDetails) === null || _35 === void 0 ? void 0 : _35.applicantInfo) === null || _36 === void 0 ? void 0 : _36.resumeName : filename,
                "skillsUsed": this.talentDetailsForm.get('basicDetails').get('skillsUsed').value,
                "fbApplicantEducation": educationdetail,
                "fbApplicantEmployment": employeementdetail,
                "createdDate": new Date(),
                "country": ((_38 = (_37 = this.getCandidateDetails) === null || _37 === void 0 ? void 0 : _37.applicantInfo) === null || _38 === void 0 ? void 0 : _38.country) ? (_40 = (_39 = this.getCandidateDetails) === null || _39 === void 0 ? void 0 : _39.applicantInfo) === null || _40 === void 0 ? void 0 : _40.country : this.talentDetailsForm.get('basicDetails').get('country').value,
                "stateProvinceName": ((_42 = (_41 = this.getCandidateDetails) === null || _41 === void 0 ? void 0 : _41.applicantInfo) === null || _42 === void 0 ? void 0 : _42.stateProvinceName) ? (_44 = (_43 = this.getCandidateDetails) === null || _43 === void 0 ? void 0 : _43.applicantInfo) === null || _44 === void 0 ? void 0 : _44.stateProvinceName : this.talentDetailsForm.get('basicDetails').get('state').value,
                "applicantSourceRefCode": "TALENTPOOL",
                "applicantSourceInputType": "TP_APP_INDIVIDUAL",
                "applicantSourceRefName": (_45 = this.sourceInfo) === null || _45 === void 0 ? void 0 : _45.name,
                "companyId": this.getCompanyId,
            };
        }
        this.subscription[this.subscription.length] = this.talentEditDetailsService.saveInfo(this.payload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.disabledFlag = true;
            if (response.data) {
                const file = this.newTalentUploadService.getDocData;
                const docId = this.newTalentUploadService.getDocId;
                this.toastr.success(response.message, 'Success');
                if (file && docId) {
                    let payload = new FormData();
                    payload.append("applicantSourceRefCode", "TALENTPOOL");
                    payload.append('file', file);
                    payload.append("applicantId", response.data.id);
                    payload.append("docId", docId);
                    this.subscription[this.subscription.length] = this.newTalentUploadService.uploadDocument(payload)
                        .pipe(takeUntil(this.observableSubscription$))
                        .subscribe((response) => {
                    });
                }
                if (response.status === 200) {
                    sessionStorage.removeItem('fbFormDataDTO');
                    sessionStorage.removeItem('getSourceValue');
                    sessionStorage.removeItem('uploadedFileName');
                    sessionStorage.removeItem('getSupplierValue');
                    sessionStorage.removeItem('getSupplierNameValue');
                    this.backToParentPage();
                }
            }
        });
    }
    backToParentPage() {
        let selectedMenu = (JSON.parse(sessionStorage.getItem('selectedMenu')));
        let getPageFormId = selectedMenu.pageFormId;
        let formName = sessionStorage.getItem('formName');
        if ((this.candidateId != null || 'selectedjobposition' in sessionStorage) && ((this.editFlowName == 'parsing_details') || formName !== 'Talent Pool')) {
            var pageFormId = parseInt(sessionStorage.getItem("parentPageFormId")) ? parseInt(sessionStorage.getItem("parentPageFormId")) : getPageFormId;
            sessionStorage.setItem('backtojobopening', sessionStorage.getItem('true'));
            sessionStorage.setItem('idToGetDetails', sessionStorage.getItem('selectedjobposition'));
            sessionStorage.setItem('AttendanceDataId', sessionStorage.getItem('selectedjobposition'));
            sessionStorage.setItem('fbFormDataDTO', sessionStorage.getItem('selectedjobpositionfbFormDataDTO'));
        }
        else if (this.editFlowName == 'view_candidate') {
            var pageFormId = JSON.parse(sessionStorage.getItem("currentPageFormId"));
        }
        else {
            var pageFormId = JSON.parse(sessionStorage.getItem("selectedMenu"));
            pageFormId = pageFormId.pageFormId;
        }
        if (pageFormId) {
            this.customButtonActionService.getPageFormById(pageFormId)
                .pipe(take(1)).subscribe((response) => {
                if (response) {
                    const item = {
                        formType: response.buildFormatTypeId,
                        pageFormId: response.id
                    };
                    this.customButtonActionService.onLinkRedirectPageSubject.next(item);
                }
            });
        }
    }
    cancel() {
        this.backToParentPage();
    }
    ngOnDestroy() {
        this.bulkUploadDashboardService.getErrorId = '';
        this.bulkUploadDashboardService.editFlowflag = '';
    }
}
TalentEditDetailsComponent.ɵfac = function TalentEditDetailsComponent_Factory(t) { return new (t || TalentEditDetailsComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(TalentEditDetailsService), i0.ɵɵdirectiveInject(i3.BulkUploadDashboardService), i0.ɵɵdirectiveInject(i4.PrimeNGConfig), i0.ɵɵdirectiveInject(i5.CustomButtonActionService), i0.ɵɵdirectiveInject(i6.NewTalentUploadService), i0.ɵɵdirectiveInject(i7.ViewCandidateDetailsService), i0.ɵɵdirectiveInject(i8.ToastrService), i0.ɵɵdirectiveInject(i9.Store)); };
TalentEditDetailsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: TalentEditDetailsComponent, selectors: [["lib-talent-edit-details"]], inputs: { formBuilderInfo: "formBuilderInfo" }, outputs: { saveData: "saveData" }, decls: 14, vars: 10, consts: [[1, "col-row", "mb-4"], [1, "col-2"], ["class", "back-button d-inline-flex align-items-center pr-3 pl-3 mr-3 talent_edit", 3, "click", 4, "ngIf"], ["class", "edit-talent-details", 4, "ngIf"], ["header", "Confirm", 3, "visible", "modal", "baseZIndex", "draggable", "resizable", "visibleChange"], [1, "row", "mt-4"], ["type", "button", 1, "btn", "btn-success", "button-width-icon-left", "mr-3", 3, "click"], ["type", "button", 1, "btn", "border-secondary", "text-secondary", "button-width-icon-left", "mr-3", 3, "click"], [1, "back-button", "d-inline-flex", "align-items-center", "pr-3", "pl-3", "mr-3", "talent_edit", 3, "click"], ["aria-hidden", "true", 1, "fa", "fa-chevron-circle-left", "pr-1"], [1, "edit-talent-details"], [3, "formGroup", "ngSubmit"], ["formGroupName", "basicDetails", 1, "details"], [1, "col-12", "positionHeading"], [1, "row", "mt-2"], [1, "col-3"], [1, "label-cls"], ["type", "text", "pattern", "^[a-zA-Z ]*$", "formControlName", "firstName", "placeholder", "Enter your First Name", 1, "im-input", "form-control", 3, "ngClass"], ["class", "invalid-feedback", 4, "ngIf"], ["type", "text", "pattern", "^[a-zA-Z ]*$", "formControlName", "lastName", "placeholder", "Enter your Last Name", 1, "im-input", "form-control", 3, "ngClass"], ["type", "text", "pattern", "^[a-zA-Z ]*$", "formControlName", "middleName", "placeholder", "Enter your Middle Name", 1, "im-input"], ["type", "text", "pattern", "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$", "formControlName", "emailId", "placeholder", "Enter your Email Id", 1, "im-input", "form-control", 3, "ngClass"], ["type", "text", "pattern", "^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\./0-9]*$", "formControlName", "contactNumber", "placeholder", "Enter your Contact Number", 1, "im-input", "form-control", 3, "ngClass"], ["formControlName", "experience", "optionLabel", "name", "optionValue", "id", "placeholder", "Select Year", 3, "options", "ngClass"], ["formControlName", "country", "optionLabel", "name", "optionValue", "code", "placeholder", "Select", 3, "options", "ngClass", "onChange"], ["formControlName", "state", "optionLabel", "name", "optionValue", "name", "placeholder", "Select ", 3, "options", "ngClass", "onChange"], ["class", "row mt-2", 4, "ngIf"], ["formArrayName", "educations", 1, "details", "border_t", "mt-4"], ["class", "mb-4", 3, "formGroupName", 4, "ngFor", "ngForOf"], ["type", "button", 1, "new-row", 3, "click"], ["formArrayName", "employmentDetails", 1, "details", "border_t", "mt-4"], ["class", "mt-4 mb-4", 4, "ngIf"], [1, "col-1"], ["type", "submit", 1, "btn_width", "btn", "btn-success", "button-width-icon-left", 3, "disabled"], ["type", "button", 1, "btn_width", "btn", "btn-secondary", "button-width-icon-left", "mr-3", 3, "click"], [1, "invalid-feedback"], [4, "ngIf"], [1, "col-6"], ["formControlName", "skillsUsed", "separator", ",", "placeholder", "Type and press enter to add skill", 1, "skills_selection", 3, "onAdd", "onRemove"], ["formControlName", "status", "optionLabel", "name", "optionValue", "name", "placeholder", "Select", 3, "options", "onChange"], [1, "mb-4", 3, "formGroupName"], [1, "col-11", "text-secondary-header"], ["type", "button", "class", "col-1", "title", "Delete", "pTooltip", "Delete", "pButton", "", "icon", "pi pi-trash", "class", "p-button-text p-button-rounded", 3, "click", 4, "ngIf"], ["formControlName", "educationId", "optionLabel", "name", "optionValue", "id", "placeholder", "Select", 3, "options", "ngClass"], ["type", "text", "pattern", "^[a-zA-Z ]*$", "formControlName", "universityName", "placeholder", "Enter", 1, "im-input", "form-control", 3, "ngClass"], ["formControlName", "courseId", "optionLabel", "name", "optionValue", "id", "placeholder", "Select", 3, "options", "ngClass", "required"], ["formControlName", "specializationId", "optionLabel", "name", "optionValue", "id", "placeholder", "Select", 3, "options", "ngClass"], ["formControlName", "courseTypeId", "optionLabel", "name", "optionValue", "id", "placeholder", "Select", 3, "options", "ngClass"], ["formControlName", "courseStartYear", "optionLabel", "name", "optionValue", "name", "placeholder", "Select", 3, "options", "ngClass"], ["formControlName", "courseEndYear", "optionLabel", "name", "optionValue", "id", "placeholder", "Select", 3, "options", "ngClass"], ["type", "button", "title", "Delete", "pTooltip", "Delete", "pButton", "", "icon", "pi pi-trash", 1, "p-button-text", "p-button-rounded", 3, "click"], ["labelStyleClass", "employementRadio", "formControlName", "isCurrentEmployment", "name", "currentEmployement", "value", "1", "label", "Yes", 3, "onClick"], ["labelStyleClass", "employementRadio", "formControlName", "isCurrentEmployment", "name", "currentEmployement", "value", "0", "label", "No", 1, "ml-2", 3, "onClick"], ["formControlName", "employmentTypeId", "optionLabel", "name", "optionValue", "id", "placeholder", "Select Employment Type", 3, "options", "ngClass"], ["formControlName", "totalExperienceInYears", "optionLabel", "name", "optionValue", "id", "placeholder", "Select Year", 3, "options", "ngClass"], ["formControlName", "totalExperienceInMonths", "optionLabel", "name", "optionValue", "id", "placeholder", "Select Month", 3, "options", "ngClass"], ["class", "col-3", 4, "ngIf"], ["type", "text", "pattern", "^[a-zA-Z ]*$", "formControlName", "companyName", "placeholder", "Enter Current Company", 1, "im-input", "form-control", 3, "ngClass"], ["type", "text", "pattern", "^[a-zA-Z ]*$", "formControlName", "designation", "placeholder", "Enter Designation", 1, "im-input", "form-control", 3, "ngClass"], ["formControlName", "joiningDateInYear", "optionLabel", "name", "optionValue", "id", "placeholder", "Select Year", 3, "options", "ngClass"], ["formControlName", "joiningDateInMonth", "optionLabel", "name", "optionValue", "name", "placeholder", "Select Month", 3, "options", "ngClass"], ["formControlName", "ctcId", "optionLabel", "name", "optionValue", "id", "placeholder", "Select", 3, "options", "ngClass"], ["formControlName", "noticePeriod", "optionLabel", "name", "optionValue", "name", "placeholder", "Select Notice Period", 3, "options", "ngClass", "style", 4, "ngIf", "ngIfElse"], ["enableNoticePeriodInput", ""], ["formControlName", "jobRolesAndRespon", 2, "width", "100%", 3, "ngClass"], ["formControlName", "joiningDateInYear", "optionLabel", "name", "optionValue", "id", "placeholder", "Select Year", 3, "options"], ["formControlName", "joiningDateInMonth", "optionLabel", "name", "optionValue", "name", "placeholder", "Select Month", 3, "options"], ["formControlName", "noticePeriod", "optionLabel", "name", "optionValue", "name", "placeholder", "Select Notice Period", 3, "options", "ngClass"], ["type", "text", "formControlName", "noticePeriod", "placeholder", "Enter Notice Period", 1, "im-input", "form-control", 3, "ngClass"], ["formControlName", "endDateInYear", "optionLabel", "name", "optionValue", "id", "placeholder", "Select Year", 3, "options", "ngClass"], ["formControlName", "endDateInMonth", "optionLabel", "name", "optionValue", "name", "placeholder", "Select Month", 1, "hide_outline", 3, "options", "ngClass"], ["formControlName", "skillsUsed", "separator", ",", "placeholder", "Type and press enter to add skill", 1, "skills_selection", 3, "max", "onAdd", "onRemove"], [1, "mt-4", "mb-4"], ["class", "resume_actions row mb-1", 4, "ngFor", "ngForOf"], [1, "resume_actions", "row", "mb-1"], [1, "col-9"], [1, "col-3", "text-right", "p-2"], [1, "mr-2", "padding0", "d-inline-block"], ["pButton", "", "type", "button", "icon", "pi pi-eye", "pTooltip", "View", 1, "p-button-text", "p-button-rounded", 3, "click"], ["pButton", "", "type", "button", "icon", "pi pi-download", "pTooltip", "Download", 1, "p-button-text", "p-button-rounded", 3, "click"], ["pButton", "", "type", "button", "icon", "pi pi-trash", "pTooltip", "Delete", 1, "p-button-text", "p-button-rounded", 3, "click"], [1, "col-12"], [1, "resume_actions", "row"]], template: function TalentEditDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtemplate(2, TalentEditDetailsComponent_button_2_Template, 3, 0, "button", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, TalentEditDetailsComponent_div_3_Template, 86, 48, "div", 3);
        i0.ɵɵelementStart(4, "p-dialog", 4);
        i0.ɵɵlistener("visibleChange", function TalentEditDetailsComponent_Template_p_dialog_visibleChange_4_listener($event) { return ctx.displayBasic = $event; });
        i0.ɵɵelementStart(5, "p");
        i0.ɵɵtext(6, "Do you really want to delete this file?");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵelementStart(8, "div");
        i0.ɵɵelementStart(9, "button", 6);
        i0.ɵɵlistener("click", function TalentEditDetailsComponent_Template_button_click_9_listener() { return ctx.deleteResume(); });
        i0.ɵɵtext(10, " Yes ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div");
        i0.ɵɵelementStart(12, "button", 7);
        i0.ɵɵlistener("click", function TalentEditDetailsComponent_Template_button_click_12_listener() { return ctx.displayBasic = false; });
        i0.ɵɵtext(13, " No ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.editFlowName == "bulk" || ctx.editFlowName == "view_candidate");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.editDetailsFlag);
        i0.ɵɵadvance(1);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(9, _c2));
        i0.ɵɵproperty("visible", ctx.displayBasic)("modal", true)("baseZIndex", 10000)("draggable", false)("resizable", false);
    } }, directives: [i10.NgIf, i11.Dialog, i1$1.ɵangular_packages_forms_forms_ba, i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i1$1.FormGroupName, i1$1.DefaultValueAccessor, i1$1.PatternValidator, i1$1.NgControlStatus, i1$1.FormControlName, i10.NgClass, i12.Dropdown, i1$1.FormArrayName, i10.NgForOf, i13.Chips, i1$1.RequiredValidator, i14.Tooltip, i15.ButtonDirective, i16.RadioButton], styles: [".im-input[_ngcontent-%COMP%]{margin:0}h5[_ngcontent-%COMP%]{color:rgba(33,37,41,.75);font-weight:800}sup[_ngcontent-%COMP%]{color:#c54545}.text-secondary-header[_ngcontent-%COMP%]{color:#1aa0da!important;font-weight:800}.new-row[_ngcontent-%COMP%]{font:normal normal normal 16px/22px Source Sans Pro;letter-spacing:0;color:#01a0da;z-index:3;border:none;background:none}.border_t[_ngcontent-%COMP%]{border-top:2px dashed #ccb;padding:15px 0}.resume_actions[_ngcontent-%COMP%]{background:#f5f7f7;border-radius:5px;padding:10px;align-items:center}.resume_actions[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#6c757d;font-weight:600}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TalentEditDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'lib-talent-edit-details',
                templateUrl: 'talent-edit-details.component.html',
                styleUrls: ['talent-edit-details.component.scss']
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: TalentEditDetailsService }, { type: i3.BulkUploadDashboardService }, { type: i4.PrimeNGConfig }, { type: i5.CustomButtonActionService }, { type: i6.NewTalentUploadService }, { type: i7.ViewCandidateDetailsService }, { type: i8.ToastrService }, { type: i9.Store }]; }, { formBuilderInfo: [{
            type: Input
        }], saveData: [{
            type: Output
        }] }); })();

class TalentEditDetailsModule {
}
TalentEditDetailsModule.ɵfac = function TalentEditDetailsModule_Factory(t) { return new (t || TalentEditDetailsModule)(); };
TalentEditDetailsModule.ɵmod = i0.ɵɵdefineNgModule({ type: TalentEditDetailsModule });
TalentEditDetailsModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            PrimengLibraryModule,
            ReactiveFormsModule,
            NgxExtendedPdfViewerModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(TalentEditDetailsModule, { declarations: [TalentEditDetailsComponent], imports: [CommonModule,
        PrimengLibraryModule,
        ReactiveFormsModule,
        NgxExtendedPdfViewerModule], exports: [TalentEditDetailsComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TalentEditDetailsModule, [{
        type: NgModule,
        args: [{
                declarations: [TalentEditDetailsComponent],
                imports: [
                    CommonModule,
                    PrimengLibraryModule,
                    ReactiveFormsModule,
                    NgxExtendedPdfViewerModule
                ],
                exports: [TalentEditDetailsComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of talent-edit-details
 */

/**
 * Generated bundle index. Do not edit.
 */

export { TalentEditDetailsComponent, TalentEditDetailsModule, TalentEditDetailsService };
//# sourceMappingURL=talent-edit-details.js.map
